/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * CloudQuery OpenAPI Spec
 * Welcome to the CloudQuery API documentation! This API can be used to interact with the CloudQuery platform. The API allows you to manage your teams, usage, spend limits, plugins, addons, cloud syncs, and much more.

The API is secured using bearer tokens. To get started, you can generate an API key from the CloudQuery dashboard. For a step-by-step guide, see: https://docs.cloudquery.io/docs/deployment/generate-api-key.

The base URL for the API is `https://api.cloudquery.io`.

 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  APIKey,
  AcceptTeamInvitationBody,
  ActivatePlatform200,
  ActivatePlatform205,
  ActivatePlatformBody,
  Addon,
  AddonAsset,
  AddonCreate,
  AddonOrder,
  AddonOrderCreate,
  AddonUpdate,
  AddonVersion,
  AddonVersionUpdate,
  AuthRegistryRequestParams,
  BadRequestResponse,
  CheckUserAuthStatus200,
  ConflictResponse,
  Connector,
  ConnectorAuthFinishRequestAWS,
  ConnectorAuthFinishRequestOAuth,
  ConnectorAuthRequestAWS,
  ConnectorAuthRequestGCP,
  ConnectorAuthRequestOAuth,
  ConnectorAuthResponseAWS,
  ConnectorAuthResponseGCP,
  ConnectorAuthResponseOAuth,
  ConnectorCreate,
  ConnectorUpdate,
  CreateAddonVersionBody,
  CreatePluginVersionBody,
  CreatePluginVersionDocs201,
  CreatePluginVersionDocsBody,
  CreatePluginVersionTables201,
  CreatePluginVersionTablesBody,
  CreateSyncRunProgressBody,
  CreateTeamAPIKeyBody,
  CreateTeamBody,
  CreateTeamImages201,
  CreateTeamImagesBody,
  CreateUserToken201,
  DeletePluginVersionDocsBody,
  DeletePluginVersionTablesBody,
  DeleteTeamInvitationBody,
  DeterminePlatformTenantByEmail200,
  DeterminePlatformTenantByEmailParams,
  DockerErrorResponse,
  EmailTeamInvitationBody,
  FinalizePluginUIAssetUploadBody,
  ForbiddenResponse,
  GetConnectorAuthStatusAWS200,
  GetConnectorAuthStatusGCP200,
  GetCurrentUserMemberships200,
  GetCurrentUserMembershipsParams,
  GetGroupedTeamUsageSummaryParams,
  GetManagedDatabases200,
  GetManagedDatabasesParams,
  GetOpenAPIJSON200,
  GetPluginNotificationRequest200,
  GetSyncRunConnectorCredentials200,
  GetSyncRunConnectorIdentity200,
  GetSyncRunLogs200One,
  GetTeamMemberships200,
  GetTeamMembershipsParams,
  GetTeamSpendParams,
  GetTeamUsageSummaryParams,
  GetTestConnectionConnectorCredentials200,
  GetTestConnectionConnectorIdentity200,
  ImageURL,
  InternalErrorResponse,
  Invitation,
  ListAddon,
  ListAddonOrdersByTeam200,
  ListAddonOrdersByTeamParams,
  ListAddonVersions200,
  ListAddonVersionsParams,
  ListAddons200,
  ListAddonsByTeam200,
  ListAddonsByTeamParams,
  ListAddonsParams,
  ListConnectors200,
  ListConnectorsParams,
  ListCurrentUserInvitations200,
  ListCurrentUserInvitationsParams,
  ListInvoicesByTeam200,
  ListInvoicesByTeamParams,
  ListPlugin,
  ListPluginNotificationRequests200,
  ListPluginNotificationRequestsParams,
  ListPluginUpcomingPriceChanges200,
  ListPluginVersionDocs200,
  ListPluginVersionDocsParams,
  ListPluginVersionTables200,
  ListPluginVersionTablesParams,
  ListPluginVersions200,
  ListPluginVersionsParams,
  ListPlugins200,
  ListPluginsByTeam200,
  ListPluginsByTeamParams,
  ListPluginsParams,
  ListSubscriptionOrdersByTeam200,
  ListSubscriptionOrdersByTeamParams,
  ListSyncDestinationSyncs200,
  ListSyncDestinationSyncsParams,
  ListSyncDestinations200,
  ListSyncDestinationsParams,
  ListSyncRuns200,
  ListSyncRunsParams,
  ListSyncSourceSyncs200,
  ListSyncSourceSyncsParams,
  ListSyncSources200,
  ListSyncSourcesParams,
  ListSyncs200,
  ListSyncsParams,
  ListTeamAPIKeys200,
  ListTeamAPIKeysParams,
  ListTeamInvitations200,
  ListTeamInvitationsParams,
  ListTeamPluginUsage200,
  ListTeamPluginUsageParams,
  ListTeams200,
  ListTeamsParams,
  ListUsersByTeam200,
  ListUsersByTeamParams,
  LoginUserBody,
  ManagedDatabase,
  ManagedDatabaseCreate,
  MembershipWithTeam,
  MethodNotAllowedResponse,
  NotFoundResponse,
  PlatformFlags,
  Plugin,
  PluginAsset,
  PluginCreate,
  PluginNotificationRequest,
  PluginNotificationRequestCreate,
  PluginPrice,
  PluginPriceCreate,
  PluginTableDetails,
  PluginUpdate,
  PluginVersion,
  PluginVersionDetails,
  PluginVersionUpdate,
  PromoteSyncDestinationTestConnection,
  PromoteSyncSourceTestConnection,
  RegistryAuthToken,
  ReleaseURL,
  RemoveTeamMembershipBody,
  RenewPlatformActivation200,
  RenewPlatformActivation205,
  RenewPlatformActivationBody,
  ReplacePluginVersionDocs201,
  ReplacePluginVersionDocsBody,
  ReportPlatformDataBody,
  RequiresAuthenticationResponse,
  ResetUserPasswordBody,
  SendAnonymousEventBody,
  SendUserEventBody,
  ServiceUnavailableResponse,
  SpendSummary,
  SpendingLimit,
  SpendingLimitCreate,
  SpendingLimitUpdate,
  Sync,
  SyncCreate,
  SyncDestination,
  SyncDestinationTestConnection,
  SyncDestinationTestConnectionCreate,
  SyncDestinationUpdate,
  SyncRun,
  SyncRunDetails,
  SyncSource,
  SyncSourceTestConnection,
  SyncSourceTestConnectionCreate,
  SyncSourceUpdate,
  SyncTestConnection,
  SyncUpdate,
  Team,
  TeamSubscriptionOrder,
  TeamSubscriptionOrderCreate,
  TooManyRequestsResponse,
  UnprocessableEntityResponse,
  UpdateCurrentUserBody,
  UpdateCustomerBody,
  UpdateSyncRunBody,
  UpdateSyncTestConnectionForSyncDestinationBody,
  UpdateSyncTestConnectionForSyncSourceBody,
  UpdateTeamBody,
  UploadImageBody,
  UploadPluginUIAssets201,
  UploadPluginUIAssetsBody,
  UsageCurrent,
  UsageIncrease,
  UsageSummary,
  User,
  VerifyUserEmailBody
} from './models';

import { customFetch } from '../../utils/customFetch';
/**
 * Health check endpoint, returns 200
 */
export const healthCheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/`, method: 'GET', signal
    },
      );
    }
  

export const getHealthCheckQueryKey = () => {
    return [`/`] as const;
    }

    
export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = unknown



export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the OpenAPI definition in JSON format.
 * @summary Get OpenAPI JSON
 */
export const getOpenAPIJSON = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetOpenAPIJSON200>(
      {url: `/openapi.json`, method: 'GET', signal
    },
      );
    }
  

export const getGetOpenAPIJSONQueryKey = () => {
    return [`/openapi.json`] as const;
    }

    
export const getGetOpenAPIJSONQueryOptions = <TData = Awaited<ReturnType<typeof getOpenAPIJSON>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpenAPIJSON>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenAPIJSONQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenAPIJSON>>> = ({ signal }) => getOpenAPIJSON(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenAPIJSON>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpenAPIJSONQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenAPIJSON>>>
export type GetOpenAPIJSONQueryError = unknown


/**
 * @summary Get OpenAPI JSON
 */

export function useGetOpenAPIJSON<TData = Awaited<ReturnType<typeof getOpenAPIJSON>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpenAPIJSON>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpenAPIJSONQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Health check endpoint, returns 200
 */
export const cQHealthCheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/cq-healthcheck`, method: 'GET', signal
    },
      );
    }
  

export const getCQHealthCheckQueryKey = () => {
    return [`/cq-healthcheck`] as const;
    }

    
export const getCQHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof cQHealthCheck>>, TError = InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof cQHealthCheck>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCQHealthCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cQHealthCheck>>> = ({ signal }) => cQHealthCheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cQHealthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type CQHealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof cQHealthCheck>>>
export type CQHealthCheckQueryError = InternalErrorResponse



export function useCQHealthCheck<TData = Awaited<ReturnType<typeof cQHealthCheck>>, TError = InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof cQHealthCheck>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCQHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a URL to upload image that will be publicly accessible
 */
export const uploadImage = (
    uploadImageBody: UploadImageBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ImageURL>(
      {url: `/upload/image`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadImageBody, signal
    },
      );
    }
  


export const getUploadImageMutationOptions = <TError = InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext> => {

const mutationKey = ['uploadImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, {data: UploadImageBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = UploadImageBody
    export type UploadImageMutationError = InternalErrorResponse

    export const useUploadImage = <TError = InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        {data: UploadImageBody},
        TContext
      > => {

      const mutationOptions = getUploadImageMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all plugin notification requests
 */
export const listPluginNotificationRequests = (
    params?: ListPluginNotificationRequestsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPluginNotificationRequests200>(
      {url: `/plugin-notification-requests`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListPluginNotificationRequestsQueryKey = (params?: ListPluginNotificationRequestsParams,) => {
    return [`/plugin-notification-requests`, ...(params ? [params]: [])] as const;
    }

    
export const getListPluginNotificationRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(params?: ListPluginNotificationRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginNotificationRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginNotificationRequests>>> = ({ signal }) => listPluginNotificationRequests(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginNotificationRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginNotificationRequests>>>
export type ListPluginNotificationRequestsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useListPluginNotificationRequests<TData = Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
 params?: ListPluginNotificationRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginNotificationRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new plugin notification request.
 */
export const createPluginNotificationRequest = (
    pluginNotificationRequestCreate: PluginNotificationRequestCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PluginNotificationRequest>(
      {url: `/plugin-notification-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginNotificationRequestCreate, signal
    },
      );
    }
  


export const getCreatePluginNotificationRequestMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginNotificationRequest>>, TError,{data: PluginNotificationRequestCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPluginNotificationRequest>>, TError,{data: PluginNotificationRequestCreate}, TContext> => {

const mutationKey = ['createPluginNotificationRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginNotificationRequest>>, {data: PluginNotificationRequestCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPluginNotificationRequest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginNotificationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginNotificationRequest>>>
    export type CreatePluginNotificationRequestMutationBody = PluginNotificationRequestCreate
    export type CreatePluginNotificationRequestMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePluginNotificationRequest = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginNotificationRequest>>, TError,{data: PluginNotificationRequestCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginNotificationRequest>>,
        TError,
        {data: PluginNotificationRequestCreate},
        TContext
      > => {

      const mutationOptions = getCreatePluginNotificationRequestMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Query plugin notification request for a given plugin.
 */
export const getPluginNotificationRequest = (
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetPluginNotificationRequest200>(
      {url: `/plugin-notification-requests/${pluginTeam}/${pluginKind}/${pluginName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPluginNotificationRequestQueryKey = (pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [`/plugin-notification-requests/${pluginTeam}/${pluginKind}/${pluginName}`] as const;
    }

    
export const getGetPluginNotificationRequestQueryOptions = <TData = Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginNotificationRequestQueryKey(pluginTeam,pluginKind,pluginName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginNotificationRequest>>> = ({ signal }) => getPluginNotificationRequest(pluginTeam,pluginKind,pluginName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(pluginTeam && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginNotificationRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginNotificationRequest>>>
export type GetPluginNotificationRequestQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetPluginNotificationRequest<TData = Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginNotificationRequestQueryOptions(pluginTeam,pluginKind,pluginName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Remove plugin notification request for a given plugin.
 */
export const deletePluginNotificationRequest = (
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugin-notification-requests/${pluginTeam}/${pluginKind}/${pluginName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePluginNotificationRequestMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, TError,{pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, TError,{pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['deletePluginNotificationRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, {pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {pluginTeam,pluginKind,pluginName} = props ?? {};

          return  deletePluginNotificationRequest(pluginTeam,pluginKind,pluginName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginNotificationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginNotificationRequest>>>
    
    export type DeletePluginNotificationRequestMutationError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useDeletePluginNotificationRequest = <TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, TError,{pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginNotificationRequest>>,
        TError,
        {pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {

      const mutationOptions = getDeletePluginNotificationRequestMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all plugins
 */
export const listPlugins = (
    params?: ListPluginsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPlugins200>(
      {url: `/plugins`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListPluginsQueryKey = (params?: ListPluginsParams,) => {
    return [`/plugins`, ...(params ? [params]: [])] as const;
    }

    
export const getListPluginsQueryOptions = <TData = Awaited<ReturnType<typeof listPlugins>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(params?: ListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlugins>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlugins>>> = ({ signal }) => listPlugins(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlugins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlugins>>>
export type ListPluginsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useListPlugins<TData = Awaited<ReturnType<typeof listPlugins>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
 params?: ListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlugins>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a plugin owned by the specified team. User must be part of that team.
 */
export const createPlugin = (
    pluginCreate: PluginCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Plugin>(
      {url: `/plugins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginCreate, signal
    },
      );
    }
  


export const getCreatePluginMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlugin>>, TError,{data: PluginCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPlugin>>, TError,{data: PluginCreate}, TContext> => {

const mutationKey = ['createPlugin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlugin>>, {data: PluginCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPlugin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof createPlugin>>>
    export type CreatePluginMutationBody = PluginCreate
    export type CreatePluginMutationError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePlugin = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlugin>>, TError,{data: PluginCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlugin>>,
        TError,
        {data: PluginCreate},
        TContext
      > => {

      const mutationOptions = getCreatePluginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get details about a given plugin.
 */
export const getPlugin = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPlugin>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPluginQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}`] as const;
    }

    
export const getGetPluginQueryOptions = <TData = Awaited<ReturnType<typeof getPlugin>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlugin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginQueryKey(teamName,pluginKind,pluginName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlugin>>> = ({ signal }) => getPlugin(teamName,pluginKind,pluginName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlugin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginQueryResult = NonNullable<Awaited<ReturnType<typeof getPlugin>>>
export type GetPluginQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetPlugin<TData = Awaited<ReturnType<typeof getPlugin>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlugin>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginQueryOptions(teamName,pluginKind,pluginName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a plugin
 */
export const updatePlugin = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    pluginUpdate: PluginUpdate,
 ) => {
      
      
      return customFetch<Plugin>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pluginUpdate
    },
      );
    }
  


export const getUpdatePluginMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}, TContext> => {

const mutationKey = ['updatePlugin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlugin>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,data} = props ?? {};

          return  updatePlugin(teamName,pluginKind,pluginName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlugin>>>
    export type UpdatePluginMutationBody = PluginUpdate
    export type UpdatePluginMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdatePlugin = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlugin>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate},
        TContext
      > => {

      const mutationOptions = getUpdatePluginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete plugin by team and plugin name
 */
export const deletePluginByTeamAndPluginName = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePluginByTeamAndPluginNameMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['deletePluginByTeamAndPluginName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {teamName,pluginKind,pluginName} = props ?? {};

          return  deletePluginByTeamAndPluginName(teamName,pluginKind,pluginName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginByTeamAndPluginNameMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>>
    
    export type DeletePluginByTeamAndPluginNameMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeletePluginByTeamAndPluginName = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {

      const mutationOptions = getDeletePluginByTeamAndPluginNameMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * DEPRECATED. Plugin prices are now managed by category. This endpoint will be removed in the near future and currently returns only empty data.
 * @deprecated
 */
export const listPluginUpcomingPriceChanges = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPluginUpcomingPriceChanges200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`, method: 'GET', signal
    },
      );
    }
  

export const getListPluginUpcomingPriceChangesQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`] as const;
    }

    
export const getListPluginUpcomingPriceChangesQueryOptions = <TData = Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginUpcomingPriceChangesQueryKey(teamName,pluginKind,pluginName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>> = ({ signal }) => listPluginUpcomingPriceChanges(teamName,pluginKind,pluginName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginUpcomingPriceChangesQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>>
export type ListPluginUpcomingPriceChangesQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse


/**
 * @deprecated
 */

export function useListPluginUpcomingPriceChanges<TData = Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginUpcomingPriceChangesQueryOptions(teamName,pluginKind,pluginName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * DEPRECATED. Plugin prices are now managed by category. This endpoint will be removed in the near future and currently returns only empty data.
 * @deprecated
 */
export const createPluginUpcomingPriceChange = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    pluginPriceCreate: PluginPriceCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PluginPrice>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginPriceCreate, signal
    },
      );
    }
  


export const getCreatePluginUpcomingPriceChangeMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}, TContext> => {

const mutationKey = ['createPluginUpcomingPriceChange'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}> = (props) => {
          const {teamName,pluginKind,pluginName,data} = props ?? {};

          return  createPluginUpcomingPriceChange(teamName,pluginKind,pluginName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginUpcomingPriceChangeMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>>
    export type CreatePluginUpcomingPriceChangeMutationBody = PluginPriceCreate
    export type CreatePluginUpcomingPriceChangeMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useCreatePluginUpcomingPriceChange = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate},
        TContext
      > => {

      const mutationOptions = getCreatePluginUpcomingPriceChangeMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * DEPRECATED. Plugin prices are now managed by category. This endpoint will be removed in the near future and currently returns only empty data.
 * @deprecated
 */
export const deletePluginUpcomingPriceChanges = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePluginUpcomingPriceChangesMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['deletePluginUpcomingPriceChanges'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {teamName,pluginKind,pluginName} = props ?? {};

          return  deletePluginUpcomingPriceChanges(teamName,pluginKind,pluginName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginUpcomingPriceChangesMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>>
    
    export type DeletePluginUpcomingPriceChangesMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useDeletePluginUpcomingPriceChanges = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {

      const mutationOptions = getDeletePluginUpcomingPriceChangesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all versions for a given plugin
 */
export const listPluginVersions = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPluginVersions200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListPluginVersionsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getListPluginVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginVersions>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginVersionsQueryKey(teamName,pluginKind,pluginName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginVersions>>> = ({ signal }) => listPluginVersions(teamName,pluginKind,pluginName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginVersions>>>
export type ListPluginVersionsQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginVersions<TData = Awaited<ReturnType<typeof listPluginVersions>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginVersionsQueryOptions(teamName,pluginKind,pluginName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get details about a given plugin version.
 */
export const getPluginVersion = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PluginVersionDetails>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPluginVersionQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`] as const;
    }

    
export const getGetPluginVersionQueryOptions = <TData = Awaited<ReturnType<typeof getPluginVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersion>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginVersionQueryKey(teamName,pluginKind,pluginName,versionName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginVersion>>> = ({ signal }) => getPluginVersion(teamName,pluginKind,pluginName,versionName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginVersion>>>
export type GetPluginVersionQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetPluginVersion<TData = Awaited<ReturnType<typeof getPluginVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersion>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginVersionQueryOptions(teamName,pluginKind,pluginName,versionName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new plugin version, or update a draft version
 */
export const createPluginVersion = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    createPluginVersionBody: CreatePluginVersionBody,
 ) => {
      
      
      return customFetch<PluginVersion>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createPluginVersionBody
    },
      );
    }
  


export const getCreatePluginVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}, TContext> => {

const mutationKey = ['createPluginVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  createPluginVersion(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginVersion>>>
    export type CreatePluginVersionMutationBody = CreatePluginVersionBody
    export type CreatePluginVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useCreatePluginVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody},
        TContext
      > => {

      const mutationOptions = getCreatePluginVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Update a given plugin version
 */
export const updatePluginVersion = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    pluginVersionUpdate: PluginVersionUpdate,
 ) => {
      
      
      return customFetch<PluginVersion>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pluginVersionUpdate
    },
      );
    }
  


export const getUpdatePluginVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}, TContext> => {

const mutationKey = ['updatePluginVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  updatePluginVersion(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updatePluginVersion>>>
    export type UpdatePluginVersionMutationBody = PluginVersionUpdate
    export type UpdatePluginVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdatePluginVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate},
        TContext
      > => {

      const mutationOptions = getUpdatePluginVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all documentation pages for a given plugin version
 */
export const listPluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPluginVersionDocs200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListPluginVersionDocsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, ...(params ? [params]: [])] as const;
    }

    
export const getListPluginVersionDocsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginVersionDocs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionDocs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginVersionDocsQueryKey(teamName,pluginKind,pluginName,versionName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginVersionDocs>>> = ({ signal }) => listPluginVersionDocs(teamName,pluginKind,pluginName,versionName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionDocs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginVersionDocsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginVersionDocs>>>
export type ListPluginVersionDocsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginVersionDocs<TData = Awaited<ReturnType<typeof listPluginVersionDocs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionDocs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginVersionDocsQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create or update one or more plugin version docs pages
 */
export const createPluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    createPluginVersionDocsBody: CreatePluginVersionDocsBody,
 ) => {
      
      
      return customFetch<CreatePluginVersionDocs201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createPluginVersionDocsBody
    },
      );
    }
  


export const getCreatePluginVersionDocsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}, TContext> => {

const mutationKey = ['createPluginVersionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  createPluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginVersionDocs>>>
    export type CreatePluginVersionDocsMutationBody = CreatePluginVersionDocsBody
    export type CreatePluginVersionDocsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePluginVersionDocs = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody},
        TContext
      > => {

      const mutationOptions = getCreatePluginVersionDocsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Replace (override) multiple plugin version docs pages
 */
export const replacePluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    replacePluginVersionDocsBody: ReplacePluginVersionDocsBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ReplacePluginVersionDocs201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: replacePluginVersionDocsBody, signal
    },
      );
    }
  


export const getReplacePluginVersionDocsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}, TContext> => {

const mutationKey = ['replacePluginVersionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replacePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  replacePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplacePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof replacePluginVersionDocs>>>
    export type ReplacePluginVersionDocsMutationBody = ReplacePluginVersionDocsBody
    export type ReplacePluginVersionDocsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useReplacePluginVersionDocs = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof replacePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody},
        TContext
      > => {

      const mutationOptions = getReplacePluginVersionDocsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete one or more plugin version docs pages.
 */
export const deletePluginVersionDocs = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    deletePluginVersionDocsBody: DeletePluginVersionDocsBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deletePluginVersionDocsBody
    },
      );
    }
  


export const getDeletePluginVersionDocsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}, TContext> => {

const mutationKey = ['deletePluginVersionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  deletePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginVersionDocs>>>
    export type DeletePluginVersionDocsMutationBody = DeletePluginVersionDocsBody
    export type DeletePluginVersionDocsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeletePluginVersionDocs = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody},
        TContext
      > => {

      const mutationOptions = getDeletePluginVersionDocsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List tables for a given plugin version. This only applies to source plugins.
 */
export const listPluginVersionTables = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPluginVersionTables200>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListPluginVersionTablesQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, ...(params ? [params]: [])] as const;
    }

    
export const getListPluginVersionTablesQueryOptions = <TData = Awaited<ReturnType<typeof listPluginVersionTables>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionTables>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginVersionTablesQueryKey(teamName,pluginKind,pluginName,versionName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginVersionTables>>> = ({ signal }) => listPluginVersionTables(teamName,pluginKind,pluginName,versionName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionTables>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginVersionTablesQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginVersionTables>>>
export type ListPluginVersionTablesQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginVersionTables<TData = Awaited<ReturnType<typeof listPluginVersionTables>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionTables>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginVersionTablesQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create or update one or more plugin version tables. This only applies to source plugins, and can only be done if the plugin version is in draft.
 */
export const createPluginVersionTables = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    createPluginVersionTablesBody: CreatePluginVersionTablesBody,
 ) => {
      
      
      return customFetch<CreatePluginVersionTables201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createPluginVersionTablesBody
    },
      );
    }
  


export const getCreatePluginVersionTablesMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}, TContext> => {

const mutationKey = ['createPluginVersionTables'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  createPluginVersionTables(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginVersionTables>>>
    export type CreatePluginVersionTablesMutationBody = CreatePluginVersionTablesBody
    export type CreatePluginVersionTablesMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePluginVersionTables = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody},
        TContext
      > => {

      const mutationOptions = getCreatePluginVersionTablesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete one or more plugin version tables.
 */
export const deletePluginVersionTables = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    deletePluginVersionTablesBody: DeletePluginVersionTablesBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deletePluginVersionTablesBody
    },
      );
    }
  


export const getDeletePluginVersionTablesMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}, TContext> => {

const mutationKey = ['deletePluginVersionTables'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  deletePluginVersionTables(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginVersionTables>>>
    export type DeletePluginVersionTablesMutationBody = DeletePluginVersionTablesBody
    export type DeletePluginVersionTablesMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeletePluginVersionTables = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody},
        TContext
      > => {

      const mutationOptions = getDeletePluginVersionTablesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get schema for a given table and plugin version. This only applies to source plugins.
 */
export const getPluginVersionTable = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PluginTableDetails>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPluginVersionTableQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`] as const;
    }

    
export const getGetPluginVersionTableQueryOptions = <TData = Awaited<ReturnType<typeof getPluginVersionTable>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersionTable>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginVersionTableQueryKey(teamName,pluginKind,pluginName,versionName,tableName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginVersionTable>>> = ({ signal }) => getPluginVersionTable(teamName,pluginKind,pluginName,versionName,tableName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginVersionTable>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginVersionTableQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginVersionTable>>>
export type GetPluginVersionTableQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetPluginVersionTable<TData = Awaited<ReturnType<typeof getPluginVersionTable>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersionTable>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginVersionTableQueryOptions(teamName,pluginKind,pluginName,versionName,tableName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Download an asset for a given plugin version and target
 */
export const downloadPluginAsset = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PluginAsset>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`, method: 'GET', signal
    },
      );
    }
  

export const getDownloadPluginAssetQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [`/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`] as const;
    }

    
export const getDownloadPluginAssetQueryOptions = <TData = Awaited<ReturnType<typeof downloadPluginAsset>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAsset>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPluginAssetQueryKey(teamName,pluginKind,pluginName,versionName,targetName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPluginAsset>>> = ({ signal }) => downloadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPluginAssetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPluginAsset>>>
export type DownloadPluginAssetQueryError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadPluginAsset<TData = Awaited<ReturnType<typeof downloadPluginAsset>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAsset>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPluginAssetQueryOptions(teamName,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a URL to upload an asset for a given plugin version and target
 */
export const uploadPluginAsset = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ReleaseURL>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`, method: 'POST', signal
    },
      );
    }
  


export const getUploadPluginAssetMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext> => {

const mutationKey = ['uploadPluginAsset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPluginAsset>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,targetName} = props ?? {};

          return  uploadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadPluginAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPluginAsset>>>
    
    export type UploadPluginAssetMutationError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useUploadPluginAsset = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadPluginAsset>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string},
        TContext
      > => {

      const mutationOptions = getUploadPluginAssetMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get URLs to upload UI assets for a given plugin version
 */
export const uploadPluginUIAssets = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    uploadPluginUIAssetsBody: UploadPluginUIAssetsBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<UploadPluginUIAssets201>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadPluginUIAssetsBody, signal
    },
      );
    }
  


export const getUploadPluginUIAssetsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}, TContext> => {

const mutationKey = ['uploadPluginUIAssets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  uploadPluginUIAssets(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadPluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPluginUIAssets>>>
    export type UploadPluginUIAssetsMutationBody = UploadPluginUIAssetsBody
    export type UploadPluginUIAssetsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useUploadPluginUIAssets = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadPluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody},
        TContext
      > => {

      const mutationOptions = getUploadPluginUIAssetsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Finalize UI asset upload
 */
export const finalizePluginUIAssetUpload = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    finalizePluginUIAssetUploadBody: FinalizePluginUIAssetUploadBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: finalizePluginUIAssetUploadBody
    },
      );
    }
  


export const getFinalizePluginUIAssetUploadMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}, TContext> => {

const mutationKey = ['finalizePluginUIAssetUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  finalizePluginUIAssetUpload(teamName,pluginKind,pluginName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FinalizePluginUIAssetUploadMutationResult = NonNullable<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>>
    export type FinalizePluginUIAssetUploadMutationBody = FinalizePluginUIAssetUploadBody
    export type FinalizePluginUIAssetUploadMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useFinalizePluginUIAssetUpload = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody},
        TContext
      > => {

      const mutationOptions = getFinalizePluginUIAssetUploadMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Remove UI assets for a given plugin version
 */
export const removePluginUIAssets = (
    teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`, method: 'DELETE'
    },
      );
    }
  


export const getRemovePluginUIAssetsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext> => {

const mutationKey = ['removePluginUIAssets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName} = props ?? {};

          return  removePluginUIAssets(teamName,pluginKind,pluginName,versionName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemovePluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof removePluginUIAssets>>>
    
    export type RemovePluginUIAssetsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useRemovePluginUIAssets = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof removePluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string},
        TContext
      > => {

      const mutationOptions = getRemovePluginUIAssetsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all addons
 */
export const listAddons = (
    params?: ListAddonsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListAddons200>(
      {url: `/addons`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListAddonsQueryKey = (params?: ListAddonsParams,) => {
    return [`/addons`, ...(params ? [params]: [])] as const;
    }

    
export const getListAddonsQueryOptions = <TData = Awaited<ReturnType<typeof listAddons>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(params?: ListAddonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddons>>> = ({ signal }) => listAddons(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonsQueryResult = NonNullable<Awaited<ReturnType<typeof listAddons>>>
export type ListAddonsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useListAddons<TData = Awaited<ReturnType<typeof listAddons>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
 params?: ListAddonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create an addon owned by the specified team. User must be part of that team.
 */
export const createAddon = (
    addonCreate: AddonCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Addon>(
      {url: `/addons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addonCreate, signal
    },
      );
    }
  


export const getCreateAddonMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddon>>, TError,{data: AddonCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAddon>>, TError,{data: AddonCreate}, TContext> => {

const mutationKey = ['createAddon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddon>>, {data: AddonCreate}> = (props) => {
          const {data} = props ?? {};

          return  createAddon(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAddonMutationResult = NonNullable<Awaited<ReturnType<typeof createAddon>>>
    export type CreateAddonMutationBody = AddonCreate
    export type CreateAddonMutationError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateAddon = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddon>>, TError,{data: AddonCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAddon>>,
        TError,
        {data: AddonCreate},
        TContext
      > => {

      const mutationOptions = getCreateAddonMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get details about a given addon.
 */
export const getAddon = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListAddon>(
      {url: `/addons/${teamName}/${addonType}/${addonName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAddonQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,) => {
    return [`/addons/${teamName}/${addonType}/${addonName}`] as const;
    }

    
export const getGetAddonQueryOptions = <TData = Awaited<ReturnType<typeof getAddon>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddon>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddonQueryKey(teamName,addonType,addonName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddon>>> = ({ signal }) => getAddon(teamName,addonType,addonName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddon>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddonQueryResult = NonNullable<Awaited<ReturnType<typeof getAddon>>>
export type GetAddonQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetAddon<TData = Awaited<ReturnType<typeof getAddon>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddon>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddonQueryOptions(teamName,addonType,addonName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update an Addon
 */
export const updateAddon = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    addonUpdate: AddonUpdate,
 ) => {
      
      
      return customFetch<Addon>(
      {url: `/addons/${teamName}/${addonType}/${addonName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: addonUpdate
    },
      );
    }
  


export const getUpdateAddonMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddon>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAddon>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}, TContext> => {

const mutationKey = ['updateAddon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAddon>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}> = (props) => {
          const {teamName,addonType,addonName,data} = props ?? {};

          return  updateAddon(teamName,addonType,addonName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAddonMutationResult = NonNullable<Awaited<ReturnType<typeof updateAddon>>>
    export type UpdateAddonMutationBody = AddonUpdate
    export type UpdateAddonMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateAddon = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddon>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAddon>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateAddonMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete addon by team and addon name
 */
export const deleteAddonByTeamAndName = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/addons/${teamName}/${addonType}/${addonName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAddonByTeamAndNameMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string}, TContext> => {

const mutationKey = ['deleteAddonByTeamAndName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string}> = (props) => {
          const {teamName,addonType,addonName} = props ?? {};

          return  deleteAddonByTeamAndName(teamName,addonType,addonName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddonByTeamAndNameMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>>
    
    export type DeleteAddonByTeamAndNameMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteAddonByTeamAndName = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddonByTeamAndName>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string},
        TContext
      > => {

      const mutationOptions = getDeleteAddonByTeamAndNameMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all versions for a given addon
 */
export const listAddonVersions = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListAddonVersions200>(
      {url: `/addons/${teamName}/${addonType}/${addonName}/versions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListAddonVersionsQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams,) => {
    return [`/addons/${teamName}/${addonType}/${addonName}/versions`, ...(params ? [params]: [])] as const;
    }

    
export const getListAddonVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listAddonVersions>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonVersions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonVersionsQueryKey(teamName,addonType,addonName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddonVersions>>> = ({ signal }) => listAddonVersions(teamName,addonType,addonName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddonVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAddonVersions>>>
export type ListAddonVersionsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListAddonVersions<TData = Awaited<ReturnType<typeof listAddonVersions>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonVersions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonVersionsQueryOptions(teamName,addonType,addonName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get details about a given addon version.
 */
export const getAddonVersion = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<AddonVersion>(
      {url: `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAddonVersionQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {
    return [`/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`] as const;
    }

    
export const getGetAddonVersionQueryOptions = <TData = Awaited<ReturnType<typeof getAddonVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonVersion>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddonVersionQueryKey(teamName,addonType,addonName,versionName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddonVersion>>> = ({ signal }) => getAddonVersion(teamName,addonType,addonName,versionName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddonVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddonVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getAddonVersion>>>
export type GetAddonVersionQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetAddonVersion<TData = Awaited<ReturnType<typeof getAddonVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonVersion>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddonVersionQueryOptions(teamName,addonType,addonName,versionName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new addon version, or update a draft version
 */
export const createAddonVersion = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
    createAddonVersionBody: CreateAddonVersionBody,
 ) => {
      
      
      return customFetch<AddonVersion>(
      {url: `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createAddonVersionBody
    },
      );
    }
  


export const getCreateAddonVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}, TContext> => {

const mutationKey = ['createAddonVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddonVersion>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}> = (props) => {
          const {teamName,addonType,addonName,versionName,data} = props ?? {};

          return  createAddonVersion(teamName,addonType,addonName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAddonVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createAddonVersion>>>
    export type CreateAddonVersionMutationBody = CreateAddonVersionBody
    export type CreateAddonVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useCreateAddonVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAddonVersion>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody},
        TContext
      > => {

      const mutationOptions = getCreateAddonVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Update a given addon version
 */
export const updateAddonVersion = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
    addonVersionUpdate: AddonVersionUpdate,
 ) => {
      
      
      return customFetch<AddonVersion>(
      {url: `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: addonVersionUpdate
    },
      );
    }
  


export const getUpdateAddonVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}, TContext> => {

const mutationKey = ['updateAddonVersion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAddonVersion>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}> = (props) => {
          const {teamName,addonType,addonName,versionName,data} = props ?? {};

          return  updateAddonVersion(teamName,addonType,addonName,versionName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAddonVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAddonVersion>>>
    export type UpdateAddonVersionMutationBody = AddonVersionUpdate
    export type UpdateAddonVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateAddonVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAddonVersion>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateAddonVersionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Download an asset for a given version
 */
export const downloadAddonAsset = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<AddonAsset>(
      {url: `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}/assets`, method: 'GET', signal
    },
      );
    }
  

export const getDownloadAddonAssetQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {
    return [`/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}/assets`] as const;
    }

    
export const getDownloadAddonAssetQueryOptions = <TData = Awaited<ReturnType<typeof downloadAddonAsset>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAsset>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAddonAssetQueryKey(teamName,addonType,addonName,versionName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAddonAsset>>> = ({ signal }) => downloadAddonAsset(teamName,addonType,addonName,versionName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadAddonAssetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAddonAsset>>>
export type DownloadAddonAssetQueryError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadAddonAsset<TData = Awaited<ReturnType<typeof downloadAddonAsset>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAsset>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadAddonAssetQueryOptions(teamName,addonType,addonName,versionName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a URL to upload an asset for a given addon version
 */
export const uploadAddonAsset = (
    teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ReleaseURL>(
      {url: `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}/assets`, method: 'POST', signal
    },
      );
    }
  


export const getUploadAddonAssetMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAddonAsset>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadAddonAsset>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}, TContext> => {

const mutationKey = ['uploadAddonAsset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAddonAsset>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}> = (props) => {
          const {teamName,addonType,addonName,versionName} = props ?? {};

          return  uploadAddonAsset(teamName,addonType,addonName,versionName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadAddonAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAddonAsset>>>
    
    export type UploadAddonAssetMutationError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useUploadAddonAsset = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAddonAsset>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadAddonAsset>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string},
        TContext
      > => {

      const mutationOptions = getUploadAddonAssetMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all teams
 */
export const listTeams = (
    params?: ListTeamsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListTeams200>(
      {url: `/teams`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListTeamsQueryKey = (params?: ListTeamsParams,) => {
    return [`/teams`, ...(params ? [params]: [])] as const;
    }

    
export const getListTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listTeams>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(params?: ListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeams>>> = ({ signal }) => listTeams(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeams>>>
export type ListTeamsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListTeams<TData = Awaited<ReturnType<typeof listTeams>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 params?: ListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a team owned by the current user.
 */
export const createTeam = (
    createTeamBody: CreateTeamBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Team>(
      {url: `/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTeamBody, signal
    },
      );
    }
  


export const getCreateTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: CreateTeamBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: CreateTeamBody}, TContext> => {

const mutationKey = ['createTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeam>>, {data: CreateTeamBody}> = (props) => {
          const {data} = props ?? {};

          return  createTeam(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>
    export type CreateTeamMutationBody = CreateTeamBody
    export type CreateTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: CreateTeamBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeam>>,
        TError,
        {data: CreateTeamBody},
        TContext
      > => {

      const mutationOptions = getCreateTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a team by name
 */
export const getTeamByName = (
    teamName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Team>(
      {url: `/teams/${teamName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTeamByNameQueryKey = (teamName: string,) => {
    return [`/teams/${teamName}`] as const;
    }

    
export const getGetTeamByNameQueryOptions = <TData = Awaited<ReturnType<typeof getTeamByName>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamByName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamByNameQueryKey(teamName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamByName>>> = ({ signal }) => getTeamByName(teamName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamByName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamByName>>>
export type GetTeamByNameQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamByName<TData = Awaited<ReturnType<typeof getTeamByName>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamByName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamByNameQueryOptions(teamName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update team attributes
 */
export const updateTeam = (
    teamName: string,
    updateTeamBody: UpdateTeamBody,
 ) => {
      
      
      return customFetch<Team>(
      {url: `/teams/${teamName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamBody
    },
      );
    }
  


export const getUpdateTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamName: string;data: UpdateTeamBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamName: string;data: UpdateTeamBody}, TContext> => {

const mutationKey = ['updateTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeam>>, {teamName: string;data: UpdateTeamBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  updateTeam(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeam>>>
    export type UpdateTeamMutationBody = UpdateTeamBody
    export type UpdateTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamName: string;data: UpdateTeamBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTeam>>,
        TError,
        {teamName: string;data: UpdateTeamBody},
        TContext
      > => {

      const mutationOptions = getUpdateTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete team
 */
export const deleteTeam = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deleteTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deleteTeam(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>
    
    export type DeleteTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getDeleteTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get URLs to upload images for a given team
 */
export const createTeamImages = (
    teamName: string,
    createTeamImagesBody: CreateTeamImagesBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<CreateTeamImages201>(
      {url: `/teams/${teamName}/images`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTeamImagesBody, signal
    },
      );
    }
  


export const getCreateTeamImagesMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamImages>>, TError,{teamName: string;data: CreateTeamImagesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTeamImages>>, TError,{teamName: string;data: CreateTeamImagesBody}, TContext> => {

const mutationKey = ['createTeamImages'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamImages>>, {teamName: string;data: CreateTeamImagesBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createTeamImages(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamImagesMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamImages>>>
    export type CreateTeamImagesMutationBody = CreateTeamImagesBody
    export type CreateTeamImagesMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useCreateTeamImages = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamImages>>, TError,{teamName: string;data: CreateTeamImagesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamImages>>,
        TError,
        {teamName: string;data: CreateTeamImagesBody},
        TContext
      > => {

      const mutationOptions = getCreateTeamImagesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all plugins for the team.
 */
export const listPluginsByTeam = (
    teamName: string,
    params?: ListPluginsByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListPluginsByTeam200>(
      {url: `/teams/${teamName}/plugins`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListPluginsByTeamQueryKey = (teamName: string,
    params?: ListPluginsByTeamParams,) => {
    return [`/teams/${teamName}/plugins`, ...(params ? [params]: [])] as const;
    }

    
export const getListPluginsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listPluginsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginsByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginsByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginsByTeam>>> = ({ signal }) => listPluginsByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginsByTeam>>>
export type ListPluginsByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginsByTeam<TData = Awaited<ReturnType<typeof listPluginsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginsByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginsByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete plugins by team
 */
export const deletePluginsByTeam = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/plugins`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePluginsByTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginsByTeam>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginsByTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deletePluginsByTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginsByTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deletePluginsByTeam(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginsByTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginsByTeam>>>
    
    export type DeletePluginsByTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeletePluginsByTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginsByTeam>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginsByTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getDeletePluginsByTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all addons for the team.
 */
export const listAddonsByTeam = (
    teamName: string,
    params?: ListAddonsByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListAddonsByTeam200>(
      {url: `/teams/${teamName}/addons`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListAddonsByTeamQueryKey = (teamName: string,
    params?: ListAddonsByTeamParams,) => {
    return [`/teams/${teamName}/addons`, ...(params ? [params]: [])] as const;
    }

    
export const getListAddonsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listAddonsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListAddonsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonsByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonsByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddonsByTeam>>> = ({ signal }) => listAddonsByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddonsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listAddonsByTeam>>>
export type ListAddonsByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListAddonsByTeam<TData = Awaited<ReturnType<typeof listAddonsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListAddonsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonsByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonsByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete addons by team
 */
export const deleteAddonsByTeam = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/addons`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAddonsByTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonsByTeam>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddonsByTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deleteAddonsByTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddonsByTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deleteAddonsByTeam(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddonsByTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddonsByTeam>>>
    
    export type DeleteAddonsByTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteAddonsByTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonsByTeam>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddonsByTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getDeleteAddonsByTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all addon orders for the team.
 */
export const listAddonOrdersByTeam = (
    teamName: string,
    params?: ListAddonOrdersByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListAddonOrdersByTeam200>(
      {url: `/teams/${teamName}/addon-orders`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListAddonOrdersByTeamQueryKey = (teamName: string,
    params?: ListAddonOrdersByTeamParams,) => {
    return [`/teams/${teamName}/addon-orders`, ...(params ? [params]: [])] as const;
    }

    
export const getListAddonOrdersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListAddonOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonOrdersByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddonOrdersByTeam>>> = ({ signal }) => listAddonOrdersByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonOrdersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listAddonOrdersByTeam>>>
export type ListAddonOrdersByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListAddonOrdersByTeam<TData = Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListAddonOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonOrdersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Start the checkout process for an addon order.
 */
export const createAddonOrderForTeam = (
    teamName: string,
    addonOrderCreate: AddonOrderCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<AddonOrder>(
      {url: `/teams/${teamName}/addon-orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addonOrderCreate, signal
    },
      );
    }
  


export const getCreateAddonOrderForTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonOrderForTeam>>, TError,{teamName: string;data: AddonOrderCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAddonOrderForTeam>>, TError,{teamName: string;data: AddonOrderCreate}, TContext> => {

const mutationKey = ['createAddonOrderForTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddonOrderForTeam>>, {teamName: string;data: AddonOrderCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createAddonOrderForTeam(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAddonOrderForTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createAddonOrderForTeam>>>
    export type CreateAddonOrderForTeamMutationBody = AddonOrderCreate
    export type CreateAddonOrderForTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useCreateAddonOrderForTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonOrderForTeam>>, TError,{teamName: string;data: AddonOrderCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAddonOrderForTeam>>,
        TError,
        {teamName: string;data: AddonOrderCreate},
        TContext
      > => {

      const mutationOptions = getCreateAddonOrderForTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get an addon order for the team.
 */
export const getAddonOrderByTeam = (
    teamName: string,
    addonOrderId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<AddonOrder>(
      {url: `/teams/${teamName}/addon-orders/${addonOrderId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAddonOrderByTeamQueryKey = (teamName: string,
    addonOrderId: string,) => {
    return [`/teams/${teamName}/addon-orders/${addonOrderId}`] as const;
    }

    
export const getGetAddonOrderByTeamQueryOptions = <TData = Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddonOrderByTeamQueryKey(teamName,addonOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddonOrderByTeam>>> = ({ signal }) => getAddonOrderByTeam(teamName,addonOrderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && addonOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddonOrderByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getAddonOrderByTeam>>>
export type GetAddonOrderByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetAddonOrderByTeam<TData = Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddonOrderByTeamQueryOptions(teamName,addonOrderId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get memberships to the team.
 */
export const getTeamMemberships = (
    teamName: string,
    params?: GetTeamMembershipsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetTeamMemberships200>(
      {url: `/teams/${teamName}/memberships`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTeamMembershipsQueryKey = (teamName: string,
    params?: GetTeamMembershipsParams,) => {
    return [`/teams/${teamName}/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTeamMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamMemberships>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: GetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberships>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamMembershipsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamMemberships>>> = ({ signal }) => getTeamMemberships(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamMemberships>>>
export type GetTeamMembershipsQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamMemberships<TData = Awaited<ReturnType<typeof getTeamMemberships>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberships>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamMembershipsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Remove a user from the team
 */
export const removeTeamMembership = (
    teamName: string,
    removeTeamMembershipBody: RemoveTeamMembershipBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/memberships`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: removeTeamMembershipBody
    },
      );
    }
  


export const getRemoveTeamMembershipMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTeamMembership>>, TError,{teamName: string;data: RemoveTeamMembershipBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeTeamMembership>>, TError,{teamName: string;data: RemoveTeamMembershipBody}, TContext> => {

const mutationKey = ['removeTeamMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTeamMembership>>, {teamName: string;data: RemoveTeamMembershipBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  removeTeamMembership(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof removeTeamMembership>>>
    export type RemoveTeamMembershipMutationBody = RemoveTeamMembershipBody
    export type RemoveTeamMembershipMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useRemoveTeamMembership = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTeamMembership>>, TError,{teamName: string;data: RemoveTeamMembershipBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeTeamMembership>>,
        TError,
        {teamName: string;data: RemoveTeamMembershipBody},
        TContext
      > => {

      const mutationOptions = getRemoveTeamMembershipMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Remove a user from the team
 * @deprecated
 */
export const deleteTeamMembership = (
    teamName: string,
    email: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/memberships/${email}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTeamMembershipMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMembership>>, TError,{teamName: string;email: string}, TContext> => {

const mutationKey = ['deleteTeamMembership'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamMembership>>, {teamName: string;email: string}> = (props) => {
          const {teamName,email} = props ?? {};

          return  deleteTeamMembership(teamName,email,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamMembership>>>
    
    export type DeleteTeamMembershipMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useDeleteTeamMembership = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamMembership>>,
        TError,
        {teamName: string;email: string},
        TContext
      > => {

      const mutationOptions = getDeleteTeamMembershipMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get monthly spending limit for team.
 */
export const getSpendingLimit = (
    teamName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SpendingLimit>(
      {url: `/teams/${teamName}/spending-limits`, method: 'GET', signal
    },
      );
    }
  

export const getGetSpendingLimitQueryKey = (teamName: string,) => {
    return [`/teams/${teamName}/spending-limits`] as const;
    }

    
export const getGetSpendingLimitQueryOptions = <TData = Awaited<ReturnType<typeof getSpendingLimit>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpendingLimit>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpendingLimitQueryKey(teamName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpendingLimit>>> = ({ signal }) => getSpendingLimit(teamName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpendingLimit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSpendingLimitQueryResult = NonNullable<Awaited<ReturnType<typeof getSpendingLimit>>>
export type GetSpendingLimitQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetSpendingLimit<TData = Awaited<ReturnType<typeof getSpendingLimit>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpendingLimit>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSpendingLimitQueryOptions(teamName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a spending limit for a team
 */
export const createSpendingLimit = (
    teamName: string,
    spendingLimitCreate: SpendingLimitCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SpendingLimit>(
      {url: `/teams/${teamName}/spending-limits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: spendingLimitCreate, signal
    },
      );
    }
  


export const getCreateSpendingLimitMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpendingLimit>>, TError,{teamName: string;data: SpendingLimitCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSpendingLimit>>, TError,{teamName: string;data: SpendingLimitCreate}, TContext> => {

const mutationKey = ['createSpendingLimit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSpendingLimit>>, {teamName: string;data: SpendingLimitCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createSpendingLimit(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSpendingLimitMutationResult = NonNullable<Awaited<ReturnType<typeof createSpendingLimit>>>
    export type CreateSpendingLimitMutationBody = SpendingLimitCreate
    export type CreateSpendingLimitMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateSpendingLimit = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpendingLimit>>, TError,{teamName: string;data: SpendingLimitCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSpendingLimit>>,
        TError,
        {teamName: string;data: SpendingLimitCreate},
        TContext
      > => {

      const mutationOptions = getCreateSpendingLimitMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Update a spending limit for a team
 */
export const updateSpendingLimit = (
    teamName: string,
    spendingLimitUpdate: SpendingLimitUpdate,
 ) => {
      
      
      return customFetch<SpendingLimit>(
      {url: `/teams/${teamName}/spending-limits`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: spendingLimitUpdate
    },
      );
    }
  


export const getUpdateSpendingLimitMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSpendingLimit>>, TError,{teamName: string;data: SpendingLimitUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSpendingLimit>>, TError,{teamName: string;data: SpendingLimitUpdate}, TContext> => {

const mutationKey = ['updateSpendingLimit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSpendingLimit>>, {teamName: string;data: SpendingLimitUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  updateSpendingLimit(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSpendingLimitMutationResult = NonNullable<Awaited<ReturnType<typeof updateSpendingLimit>>>
    export type UpdateSpendingLimitMutationBody = SpendingLimitUpdate
    export type UpdateSpendingLimitMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateSpendingLimit = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSpendingLimit>>, TError,{teamName: string;data: SpendingLimitUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSpendingLimit>>,
        TError,
        {teamName: string;data: SpendingLimitUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateSpendingLimitMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a spending limit for a team
 */
export const deleteSpendingLimit = (
    teamName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/spending-limits`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSpendingLimitMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpendingLimit>>, TError,{teamName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSpendingLimit>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deleteSpendingLimit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSpendingLimit>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deleteSpendingLimit(teamName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSpendingLimitMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSpendingLimit>>>
    
    export type DeleteSpendingLimitMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteSpendingLimit = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpendingLimit>>, TError,{teamName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSpendingLimit>>,
        TError,
        {teamName: string},
        TContext
      > => {

      const mutationOptions = getDeleteSpendingLimitMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all past invoices for the team.
 */
export const listInvoicesByTeam = (
    teamName: string,
    params?: ListInvoicesByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListInvoicesByTeam200>(
      {url: `/teams/${teamName}/invoices`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListInvoicesByTeamQueryKey = (teamName: string,
    params?: ListInvoicesByTeamParams,) => {
    return [`/teams/${teamName}/invoices`, ...(params ? [params]: [])] as const;
    }

    
export const getListInvoicesByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listInvoicesByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListInvoicesByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoicesByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoicesByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoicesByTeam>>> = ({ signal }) => listInvoicesByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoicesByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoicesByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoicesByTeam>>>
export type ListInvoicesByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListInvoicesByTeam<TData = Awaited<ReturnType<typeof listInvoicesByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListInvoicesByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoicesByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoicesByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List plugin usage for the current calendar month.
 */
export const listTeamPluginUsage = (
    teamName: string,
    params?: ListTeamPluginUsageParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListTeamPluginUsage200>(
      {url: `/teams/${teamName}/usage`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListTeamPluginUsageQueryKey = (teamName: string,
    params?: ListTeamPluginUsageParams,) => {
    return [`/teams/${teamName}/usage`, ...(params ? [params]: [])] as const;
    }

    
export const getListTeamPluginUsageQueryOptions = <TData = Awaited<ReturnType<typeof listTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListTeamPluginUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamPluginUsage>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamPluginUsageQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamPluginUsage>>> = ({ signal }) => listTeamPluginUsage(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamPluginUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamPluginUsageQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamPluginUsage>>>
export type ListTeamPluginUsageQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListTeamPluginUsage<TData = Awaited<ReturnType<typeof listTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListTeamPluginUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamPluginUsage>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamPluginUsageQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Increase the usage of a plugin. This can incur billing costs and should be used only by plugin SDKs.
 */
export const increaseTeamPluginUsage = (
    teamName: string,
    usageIncrease: UsageIncrease,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/usage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: usageIncrease, signal
    },
      );
    }
  


export const getIncreaseTeamPluginUsageMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, TError,{teamName: string;data: UsageIncrease}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, TError,{teamName: string;data: UsageIncrease}, TContext> => {

const mutationKey = ['increaseTeamPluginUsage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, {teamName: string;data: UsageIncrease}> = (props) => {
          const {teamName,data} = props ?? {};

          return  increaseTeamPluginUsage(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IncreaseTeamPluginUsageMutationResult = NonNullable<Awaited<ReturnType<typeof increaseTeamPluginUsage>>>
    export type IncreaseTeamPluginUsageMutationBody = UsageIncrease
    export type IncreaseTeamPluginUsageMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse | ServiceUnavailableResponse

    export const useIncreaseTeamPluginUsage = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, TError,{teamName: string;data: UsageIncrease}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof increaseTeamPluginUsage>>,
        TError,
        {teamName: string;data: UsageIncrease},
        TContext
      > => {

      const mutationOptions = getIncreaseTeamPluginUsageMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get plugin usage for the current calendar month.
 */
export const getTeamPluginUsage = (
    teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<UsageCurrent>(
      {url: `/teams/${teamName}/usage/${pluginTeam}/${pluginKind}/${pluginName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTeamPluginUsageQueryKey = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [`/teams/${teamName}/usage/${pluginTeam}/${pluginKind}/${pluginName}`] as const;
    }

    
export const getGetTeamPluginUsageQueryOptions = <TData = Awaited<ReturnType<typeof getTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamPluginUsage>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamPluginUsageQueryKey(teamName,pluginTeam,pluginKind,pluginName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamPluginUsage>>> = ({ signal }) => getTeamPluginUsage(teamName,pluginTeam,pluginKind,pluginName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginTeam && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamPluginUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamPluginUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamPluginUsage>>>
export type GetTeamPluginUsageQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamPluginUsage<TData = Awaited<ReturnType<typeof getTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamPluginUsage>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamPluginUsageQueryOptions(teamName,pluginTeam,pluginKind,pluginName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a summary of usage for the specified time range.
 */
export const getTeamUsageSummary = (
    teamName: string,
    params?: GetTeamUsageSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<UsageSummary>(
      {url: `/teams/${teamName}/usage-summary`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTeamUsageSummaryQueryKey = (teamName: string,
    params?: GetTeamUsageSummaryParams,) => {
    return [`/teams/${teamName}/usage-summary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    params?: GetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamUsageSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamUsageSummaryQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamUsageSummary>>> = ({ signal }) => getTeamUsageSummary(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamUsageSummary>>>
export type GetTeamUsageSummaryQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetTeamUsageSummary<TData = Awaited<ReturnType<typeof getTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamUsageSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamUsageSummaryQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a grouped summary of usage for the specified time range.
 */
export const getGroupedTeamUsageSummary = (
    teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<UsageSummary>(
      {url: `/teams/${teamName}/usage-summary/${groupBy}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetGroupedTeamUsageSummaryQueryKey = (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams,) => {
    return [`/teams/${teamName}/usage-summary/${groupBy}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGroupedTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupedTeamUsageSummaryQueryKey(teamName,groupBy,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>> = ({ signal }) => getGroupedTeamUsageSummary(teamName,groupBy,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && groupBy), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupedTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>>
export type GetGroupedTeamUsageSummaryQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetGroupedTeamUsageSummary<TData = Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGroupedTeamUsageSummaryQueryOptions(teamName,groupBy,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get team spend for defined period.
 */
export const getTeamSpend = (
    teamName: string,
    params?: GetTeamSpendParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SpendSummary>(
      {url: `/teams/${teamName}/spend`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTeamSpendQueryKey = (teamName: string,
    params?: GetTeamSpendParams,) => {
    return [`/teams/${teamName}/spend`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTeamSpendQueryOptions = <TData = Awaited<ReturnType<typeof getTeamSpend>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: GetTeamSpendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamSpend>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamSpendQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamSpend>>> = ({ signal }) => getTeamSpend(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamSpend>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamSpendQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamSpend>>>
export type GetTeamSpendQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamSpend<TData = Awaited<ReturnType<typeof getTeamSpend>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetTeamSpendParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamSpend>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamSpendQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Download an asset for a given plugin version as the current team.
 */
export const downloadPluginAssetByTeam = (
    teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<PluginAsset>(
      {url: `/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`, method: 'GET', signal
    },
      );
    }
  

export const getDownloadPluginAssetByTeamQueryKey = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [`/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`] as const;
    }

    
export const getDownloadPluginAssetByTeamQueryOptions = <TData = Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPluginAssetByTeamQueryKey(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>> = ({ signal }) => downloadPluginAssetByTeam(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && pluginTeam && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPluginAssetByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>>
export type DownloadPluginAssetByTeamQueryError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadPluginAssetByTeam<TData = Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPluginAssetByTeamQueryOptions(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Download an asset for a given addon version as the current team.
 */
export const downloadAddonAssetByTeam = (
    teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<AddonAsset>(
      {url: `/teams/${teamName}/addons/${addonTeam}/${addonType}/${addonName}/versions/${versionName}/assets`, method: 'GET', signal
    },
      );
    }
  

export const getDownloadAddonAssetByTeamQueryKey = (teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {
    return [`/teams/${teamName}/addons/${addonTeam}/${addonType}/${addonName}/versions/${versionName}/assets`] as const;
    }

    
export const getDownloadAddonAssetByTeamQueryOptions = <TData = Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAddonAssetByTeamQueryKey(teamName,addonTeam,addonType,addonName,versionName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>> = ({ signal }) => downloadAddonAssetByTeam(teamName,addonTeam,addonType,addonName,versionName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && addonTeam && addonType && addonName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadAddonAssetByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>>
export type DownloadAddonAssetByTeamQueryError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadAddonAssetByTeam<TData = Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadAddonAssetByTeamQueryOptions(teamName,addonTeam,addonType,addonName,versionName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List of open invitations to the team
 */
export const listTeamInvitations = (
    teamName: string,
    params?: ListTeamInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListTeamInvitations200>(
      {url: `/teams/${teamName}/invitations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListTeamInvitationsQueryKey = (teamName: string,
    params?: ListTeamInvitationsParams,) => {
    return [`/teams/${teamName}/invitations`, ...(params ? [params]: [])] as const;
    }

    
export const getListTeamInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listTeamInvitations>>, TError = ForbiddenResponse | InternalErrorResponse>(teamName: string,
    params?: ListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamInvitations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamInvitationsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamInvitations>>> = ({ signal }) => listTeamInvitations(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamInvitations>>>
export type ListTeamInvitationsQueryError = ForbiddenResponse | InternalErrorResponse



export function useListTeamInvitations<TData = Awaited<ReturnType<typeof listTeamInvitations>>, TError = ForbiddenResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamInvitations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamInvitationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Invite a user to join a team with their email address
 */
export const emailTeamInvitation = (
    teamName: string,
    emailTeamInvitationBody: EmailTeamInvitationBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Invitation>(
      {url: `/teams/${teamName}/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailTeamInvitationBody, signal
    },
      );
    }
  


export const getEmailTeamInvitationMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailTeamInvitation>>, TError,{teamName: string;data: EmailTeamInvitationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof emailTeamInvitation>>, TError,{teamName: string;data: EmailTeamInvitationBody}, TContext> => {

const mutationKey = ['emailTeamInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailTeamInvitation>>, {teamName: string;data: EmailTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  emailTeamInvitation(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof emailTeamInvitation>>>
    export type EmailTeamInvitationMutationBody = EmailTeamInvitationBody
    export type EmailTeamInvitationMutationError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useEmailTeamInvitation = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailTeamInvitation>>, TError,{teamName: string;data: EmailTeamInvitationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailTeamInvitation>>,
        TError,
        {teamName: string;data: EmailTeamInvitationBody},
        TContext
      > => {

      const mutationOptions = getEmailTeamInvitationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete an invitation to the team, preventing the user becoming a team member
 */
export const deleteTeamInvitation = (
    teamName: string,
    deleteTeamInvitationBody: DeleteTeamInvitationBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/invitations`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteTeamInvitationBody
    },
      );
    }
  


export const getDeleteTeamInvitationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamInvitation>>, TError,{teamName: string;data: DeleteTeamInvitationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamInvitation>>, TError,{teamName: string;data: DeleteTeamInvitationBody}, TContext> => {

const mutationKey = ['deleteTeamInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamInvitation>>, {teamName: string;data: DeleteTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  deleteTeamInvitation(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamInvitation>>>
    export type DeleteTeamInvitationMutationBody = DeleteTeamInvitationBody
    export type DeleteTeamInvitationMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteTeamInvitation = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamInvitation>>, TError,{teamName: string;data: DeleteTeamInvitationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamInvitation>>,
        TError,
        {teamName: string;data: DeleteTeamInvitationBody},
        TContext
      > => {

      const mutationOptions = getDeleteTeamInvitationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Accept an invitation to the team, creating a user membership
 */
export const acceptTeamInvitation = (
    teamName: string,
    acceptTeamInvitationBody: AcceptTeamInvitationBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<MembershipWithTeam>(
      {url: `/teams/${teamName}/invitations/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptTeamInvitationBody, signal
    },
      );
    }
  


export const getAcceptTeamInvitationMutationOptions = <TError = MembershipWithTeam | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTeamInvitation>>, TError,{teamName: string;data: AcceptTeamInvitationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptTeamInvitation>>, TError,{teamName: string;data: AcceptTeamInvitationBody}, TContext> => {

const mutationKey = ['acceptTeamInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTeamInvitation>>, {teamName: string;data: AcceptTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  acceptTeamInvitation(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTeamInvitation>>>
    export type AcceptTeamInvitationMutationBody = AcceptTeamInvitationBody
    export type AcceptTeamInvitationMutationError = MembershipWithTeam | ForbiddenResponse | InternalErrorResponse

    export const useAcceptTeamInvitation = <TError = MembershipWithTeam | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTeamInvitation>>, TError,{teamName: string;data: AcceptTeamInvitationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptTeamInvitation>>,
        TError,
        {teamName: string;data: AcceptTeamInvitationBody},
        TContext
      > => {

      const mutationOptions = getAcceptTeamInvitationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Cancel an invitation to the team, preventing the user becoming a team member
 * @deprecated
 */
export const cancelTeamInvitation = (
    teamName: string,
    email: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/invitations/${email}`, method: 'DELETE'
    },
      );
    }
  


export const getCancelTeamInvitationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTeamInvitation>>, TError,{teamName: string;email: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelTeamInvitation>>, TError,{teamName: string;email: string}, TContext> => {

const mutationKey = ['cancelTeamInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTeamInvitation>>, {teamName: string;email: string}> = (props) => {
          const {teamName,email} = props ?? {};

          return  cancelTeamInvitation(teamName,email,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTeamInvitation>>>
    
    export type CancelTeamInvitationMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useCancelTeamInvitation = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTeamInvitation>>, TError,{teamName: string;email: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelTeamInvitation>>,
        TError,
        {teamName: string;email: string},
        TContext
      > => {

      const mutationOptions = getCancelTeamInvitationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all subscription orders for the team.
 */
export const listSubscriptionOrdersByTeam = (
    teamName: string,
    params?: ListSubscriptionOrdersByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSubscriptionOrdersByTeam200>(
      {url: `/teams/${teamName}/subscription-orders`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSubscriptionOrdersByTeamQueryKey = (teamName: string,
    params?: ListSubscriptionOrdersByTeamParams,) => {
    return [`/teams/${teamName}/subscription-orders`, ...(params ? [params]: [])] as const;
    }

    
export const getListSubscriptionOrdersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListSubscriptionOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubscriptionOrdersByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>> = ({ signal }) => listSubscriptionOrdersByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSubscriptionOrdersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>>
export type ListSubscriptionOrdersByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListSubscriptionOrdersByTeam<TData = Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListSubscriptionOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSubscriptionOrdersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Start the checkout process for a subscription order.
 */
export const createSubscriptionOrderForTeam = (
    teamName: string,
    teamSubscriptionOrderCreate: TeamSubscriptionOrderCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<TeamSubscriptionOrder>(
      {url: `/teams/${teamName}/subscription-orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamSubscriptionOrderCreate, signal
    },
      );
    }
  


export const getCreateSubscriptionOrderForTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, TError,{teamName: string;data: TeamSubscriptionOrderCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, TError,{teamName: string;data: TeamSubscriptionOrderCreate}, TContext> => {

const mutationKey = ['createSubscriptionOrderForTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, {teamName: string;data: TeamSubscriptionOrderCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createSubscriptionOrderForTeam(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionOrderForTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>>
    export type CreateSubscriptionOrderForTeamMutationBody = TeamSubscriptionOrderCreate
    export type CreateSubscriptionOrderForTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateSubscriptionOrderForTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, TError,{teamName: string;data: TeamSubscriptionOrderCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>,
        TError,
        {teamName: string;data: TeamSubscriptionOrderCreate},
        TContext
      > => {

      const mutationOptions = getCreateSubscriptionOrderForTeamMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a subscription order for the team.
 */
export const getSubscriptionOrderByTeam = (
    teamName: string,
    subscriptionOrderId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<TeamSubscriptionOrder>(
      {url: `/teams/${teamName}/subscription-orders/${subscriptionOrderId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSubscriptionOrderByTeamQueryKey = (teamName: string,
    subscriptionOrderId: string,) => {
    return [`/teams/${teamName}/subscription-orders/${subscriptionOrderId}`] as const;
    }

    
export const getGetSubscriptionOrderByTeamQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    subscriptionOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionOrderByTeamQueryKey(teamName,subscriptionOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>> = ({ signal }) => getSubscriptionOrderByTeam(teamName,subscriptionOrderId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && subscriptionOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionOrderByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>>
export type GetSubscriptionOrderByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetSubscriptionOrderByTeam<TData = Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    subscriptionOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionOrderByTeamQueryOptions(teamName,subscriptionOrderId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all users in the current team.
 */
export const listUsersByTeam = (
    teamName: string,
    params?: ListUsersByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListUsersByTeam200>(
      {url: `/teams/${teamName}/users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListUsersByTeamQueryKey = (teamName: string,
    params?: ListUsersByTeamParams,) => {
    return [`/teams/${teamName}/users`, ...(params ? [params]: [])] as const;
    }

    
export const getListUsersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listUsersByTeam>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsersByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersByTeamQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersByTeam>>> = ({ signal }) => listUsersByTeam(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersByTeam>>>
export type ListUsersByTeamQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListUsersByTeam<TData = Awaited<ReturnType<typeof listUsersByTeam>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsersByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the current authenticated user from the OAuth token

 */
export const getCurrentUser = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<User>(
      {url: `/user`, method: 'GET', signal
    },
      );
    }
  

export const getGetCurrentUserQueryKey = () => {
    return [`/user`] as const;
    }

    
export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse



export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update attributes for the current authenticated user from the OAuth token
 */
export const updateCurrentUser = (
    updateCurrentUserBody: UpdateCurrentUserBody,
 ) => {
      
      
      return customFetch<User>(
      {url: `/user`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCurrentUserBody
    },
      );
    }
  


export const getUpdateCurrentUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext> => {

const mutationKey = ['updateCurrentUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurrentUser>>, {data: UpdateCurrentUserBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCurrentUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurrentUser>>>
    export type UpdateCurrentUserMutationBody = UpdateCurrentUserBody
    export type UpdateCurrentUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useUpdateCurrentUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCurrentUser>>,
        TError,
        {data: UpdateCurrentUserBody},
        TContext
      > => {

      const mutationOptions = getUpdateCurrentUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Check if the current user is authenticated
 */
export const checkUserAuthStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<CheckUserAuthStatus200>(
      {url: `/user/authenticated-status`, method: 'GET', signal
    },
      );
    }
  

export const getCheckUserAuthStatusQueryKey = () => {
    return [`/user/authenticated-status`] as const;
    }

    
export const getCheckUserAuthStatusQueryOptions = <TData = Awaited<ReturnType<typeof checkUserAuthStatus>>, TError = InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkUserAuthStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckUserAuthStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkUserAuthStatus>>> = ({ signal }) => checkUserAuthStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkUserAuthStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckUserAuthStatusQueryResult = NonNullable<Awaited<ReturnType<typeof checkUserAuthStatus>>>
export type CheckUserAuthStatusQueryError = InternalErrorResponse



export function useCheckUserAuthStatus<TData = Awaited<ReturnType<typeof checkUserAuthStatus>>, TError = InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkUserAuthStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckUserAuthStatusQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Start a session using ID token
 */
export const loginUser = (
    loginUserBody: LoginUserBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginUserBody, signal
    },
      );
    }
  


export const getLoginUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: LoginUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: LoginUserBody}, TContext> => {

const mutationKey = ['loginUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginUser>>, {data: LoginUserBody}> = (props) => {
          const {data} = props ?? {};

          return  loginUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginUserMutationResult = NonNullable<Awaited<ReturnType<typeof loginUser>>>
    export type LoginUserMutationBody = LoginUserBody
    export type LoginUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useLoginUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: LoginUserBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof loginUser>>,
        TError,
        {data: LoginUserBody},
        TContext
      > => {

      const mutationOptions = getLoginUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Logout a session
 */
export const logoutUser = (
    
 ) => {
      
      
      return customFetch<void>(
      {url: `/user/login`, method: 'DELETE'
    },
      );
    }
  


export const getLogoutUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,void, TContext> => {

const mutationKey = ['logoutUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutUser>>, void> = () => {
          

          return  logoutUser()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof logoutUser>>>
    
    export type LogoutUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useLogoutUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutUser>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Start a CLI session and create a custom token
 */
export const createUserToken = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<CreateUserToken201>(
      {url: `/user/token`, method: 'POST', signal
    },
      );
    }
  


export const getCreateUserTokenMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserToken>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserToken>>, TError,void, TContext> => {

const mutationKey = ['createUserToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserToken>>, void> = () => {
          

          return  createUserToken()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createUserToken>>>
    
    export type CreateUserTokenMutationError = BadRequestResponse | RequiresAuthenticationResponse | InternalErrorResponse

    export const useCreateUserToken = <TError = BadRequestResponse | RequiresAuthenticationResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserToken>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUserToken>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateUserTokenMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Reset user password from email
 */
export const resetUserPassword = (
    resetUserPasswordBody: ResetUserPasswordBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetUserPasswordBody, signal
    },
      );
    }
  


export const getResetUserPasswordMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: ResetUserPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: ResetUserPasswordBody}, TContext> => {

const mutationKey = ['resetUserPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, {data: ResetUserPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  resetUserPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>
    export type ResetUserPasswordMutationBody = ResetUserPasswordBody
    export type ResetUserPasswordMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useResetUserPassword = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: ResetUserPasswordBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPassword>>,
        TError,
        {data: ResetUserPasswordBody},
        TContext
      > => {

      const mutationOptions = getResetUserPasswordMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Verify user email
 */
export const verifyUserEmail = (
    verifyUserEmailBody: VerifyUserEmailBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/verify-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyUserEmailBody, signal
    },
      );
    }
  


export const getVerifyUserEmailMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyUserEmail>>, TError,{data: VerifyUserEmailBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyUserEmail>>, TError,{data: VerifyUserEmailBody}, TContext> => {

const mutationKey = ['verifyUserEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyUserEmail>>, {data: VerifyUserEmailBody}> = (props) => {
          const {data} = props ?? {};

          return  verifyUserEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyUserEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyUserEmail>>>
    export type VerifyUserEmailMutationBody = VerifyUserEmailBody
    export type VerifyUserEmailMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useVerifyUserEmail = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyUserEmail>>, TError,{data: VerifyUserEmailBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyUserEmail>>,
        TError,
        {data: VerifyUserEmailBody},
        TContext
      > => {

      const mutationOptions = getVerifyUserEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List of the current user's unaccepted invitations
 */
export const listCurrentUserInvitations = (
    params?: ListCurrentUserInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListCurrentUserInvitations200>(
      {url: `/user/invitations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListCurrentUserInvitationsQueryKey = (params?: ListCurrentUserInvitationsParams,) => {
    return [`/user/invitations`, ...(params ? [params]: [])] as const;
    }

    
export const getListCurrentUserInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError = InternalErrorResponse>(params?: ListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCurrentUserInvitationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentUserInvitations>>> = ({ signal }) => listCurrentUserInvitations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCurrentUserInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentUserInvitations>>>
export type ListCurrentUserInvitationsQueryError = InternalErrorResponse



export function useListCurrentUserInvitations<TData = Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError = InternalErrorResponse>(
 params?: ListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCurrentUserInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get memberships that the user has accepted.
 */
export const getCurrentUserMemberships = (
    params?: GetCurrentUserMembershipsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetCurrentUserMemberships200>(
      {url: `/user/memberships`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCurrentUserMembershipsQueryKey = (params?: GetCurrentUserMembershipsParams,) => {
    return [`/user/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCurrentUserMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>(params?: GetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserMemberships>>> = ({ signal }) => getCurrentUserMemberships(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentUserMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserMemberships>>>
export type GetCurrentUserMembershipsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse



export function useGetCurrentUserMemberships<TData = Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>(
 params?: GetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentUserMembershipsQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Send a user event
 */
export const sendUserEvent = (
    sendUserEventBody: SendUserEventBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendUserEventBody, signal
    },
      );
    }
  


export const getSendUserEventMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendUserEvent>>, TError,{data: SendUserEventBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendUserEvent>>, TError,{data: SendUserEventBody}, TContext> => {

const mutationKey = ['sendUserEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendUserEvent>>, {data: SendUserEventBody}> = (props) => {
          const {data} = props ?? {};

          return  sendUserEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendUserEventMutationResult = NonNullable<Awaited<ReturnType<typeof sendUserEvent>>>
    export type SendUserEventMutationBody = SendUserEventBody
    export type SendUserEventMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useSendUserEvent = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendUserEvent>>, TError,{data: SendUserEventBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendUserEvent>>,
        TError,
        {data: SendUserEventBody},
        TContext
      > => {

      const mutationOptions = getSendUserEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Send an anonymous event
 */
export const sendAnonymousEvent = (
    sendAnonymousEventBody: SendAnonymousEventBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/user/anon-event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendAnonymousEventBody, signal
    },
      );
    }
  


export const getSendAnonymousEventMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnonymousEvent>>, TError,{data: SendAnonymousEventBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAnonymousEvent>>, TError,{data: SendAnonymousEventBody}, TContext> => {

const mutationKey = ['sendAnonymousEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAnonymousEvent>>, {data: SendAnonymousEventBody}> = (props) => {
          const {data} = props ?? {};

          return  sendAnonymousEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendAnonymousEventMutationResult = NonNullable<Awaited<ReturnType<typeof sendAnonymousEvent>>>
    export type SendAnonymousEventMutationBody = SendAnonymousEventBody
    export type SendAnonymousEventMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useSendAnonymousEvent = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnonymousEvent>>, TError,{data: SendAnonymousEventBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAnonymousEvent>>,
        TError,
        {data: SendAnonymousEventBody},
        TContext
      > => {

      const mutationOptions = getSendAnonymousEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Update customer details
 */
export const updateCustomer = (
    updateCustomerBody: UpdateCustomerBody,
 ) => {
      
      
      return customFetch<void>(
      {url: `/user/customer`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomerBody
    },
      );
    }
  


export const getUpdateCustomerMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{data: UpdateCustomerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{data: UpdateCustomerBody}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {data: UpdateCustomerBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCustomer(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = UpdateCustomerBody
    export type UpdateCustomerMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateCustomer = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{data: UpdateCustomerBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {data: UpdateCustomerBody},
        TContext
      > => {

      const mutationOptions = getUpdateCustomerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Determine platform tenant by email
 */
export const determinePlatformTenantByEmail = (
    params: DeterminePlatformTenantByEmailParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<DeterminePlatformTenantByEmail200>(
      {url: `/user/tenant`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getDeterminePlatformTenantByEmailQueryKey = (params: DeterminePlatformTenantByEmailParams,) => {
    return [`/user/tenant`, ...(params ? [params]: [])] as const;
    }

    
export const getDeterminePlatformTenantByEmailQueryOptions = <TData = Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(params: DeterminePlatformTenantByEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeterminePlatformTenantByEmailQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>> = ({ signal }) => determinePlatformTenantByEmail(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type DeterminePlatformTenantByEmailQueryResult = NonNullable<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>>
export type DeterminePlatformTenantByEmailQueryError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDeterminePlatformTenantByEmail<TData = Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 params: DeterminePlatformTenantByEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDeterminePlatformTenantByEmailQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete user
 */
export const deleteUser = (
    userId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/users/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUser(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all team API Keys
 */
export const listTeamAPIKeys = (
    teamName: string,
    params?: ListTeamAPIKeysParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListTeamAPIKeys200>(
      {url: `/teams/${teamName}/apikeys`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListTeamAPIKeysQueryKey = (teamName: string,
    params?: ListTeamAPIKeysParams,) => {
    return [`/teams/${teamName}/apikeys`, ...(params ? [params]: [])] as const;
    }

    
export const getListTeamAPIKeysQueryOptions = <TData = Awaited<ReturnType<typeof listTeamAPIKeys>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamAPIKeys>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamAPIKeysQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamAPIKeys>>> = ({ signal }) => listTeamAPIKeys(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamAPIKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamAPIKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamAPIKeys>>>
export type ListTeamAPIKeysQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListTeamAPIKeys<TData = Awaited<ReturnType<typeof listTeamAPIKeys>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamAPIKeys>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamAPIKeysQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new team API Key.
 */
export const createTeamAPIKey = (
    teamName: string,
    createTeamAPIKeyBody: CreateTeamAPIKeyBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<APIKey>(
      {url: `/teams/${teamName}/apikeys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTeamAPIKeyBody, signal
    },
      );
    }
  


export const getCreateTeamAPIKeyMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamAPIKey>>, TError,{teamName: string;data: CreateTeamAPIKeyBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTeamAPIKey>>, TError,{teamName: string;data: CreateTeamAPIKeyBody}, TContext> => {

const mutationKey = ['createTeamAPIKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamAPIKey>>, {teamName: string;data: CreateTeamAPIKeyBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createTeamAPIKey(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamAPIKey>>>
    export type CreateTeamAPIKeyMutationBody = CreateTeamAPIKeyBody
    export type CreateTeamAPIKeyMutationError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateTeamAPIKey = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamAPIKey>>, TError,{teamName: string;data: CreateTeamAPIKeyBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamAPIKey>>,
        TError,
        {teamName: string;data: CreateTeamAPIKeyBody},
        TContext
      > => {

      const mutationOptions = getCreateTeamAPIKeyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete API Key. This will remove any future access by this API Key.
 */
export const deleteTeamAPIKey = (
    teamName: string,
    apikeyId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/apikeys/${apikeyId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTeamAPIKeyMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext> => {

const mutationKey = ['deleteTeamAPIKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamAPIKey>>, {teamName: string;apikeyId: string}> = (props) => {
          const {teamName,apikeyId} = props ?? {};

          return  deleteTeamAPIKey(teamName,apikeyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamAPIKey>>>
    
    export type DeleteTeamAPIKeyMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteTeamAPIKey = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamAPIKey>>,
        TError,
        {teamName: string;apikeyId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTeamAPIKeyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Performs authentication and authorization for our image registry.
 */
export const authRegistryRequest = (
    params?: AuthRegistryRequestParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<RegistryAuthToken>(
      {url: `/registry/auth`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAuthRegistryRequestQueryKey = (params?: AuthRegistryRequestParams,) => {
    return [`/registry/auth`, ...(params ? [params]: [])] as const;
    }

    
export const getAuthRegistryRequestQueryOptions = <TData = Awaited<ReturnType<typeof authRegistryRequest>>, TError = DockerErrorResponse>(params?: AuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authRegistryRequest>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthRegistryRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authRegistryRequest>>> = ({ signal }) => authRegistryRequest(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authRegistryRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthRegistryRequestQueryResult = NonNullable<Awaited<ReturnType<typeof authRegistryRequest>>>
export type AuthRegistryRequestQueryError = DockerErrorResponse



export function useAuthRegistryRequest<TData = Awaited<ReturnType<typeof authRegistryRequest>>, TError = DockerErrorResponse>(
 params?: AuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authRegistryRequest>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthRegistryRequestQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a test source connection.
 */
export const createSyncSourceTestConnection = (
    teamName: string,
    syncSourceTestConnectionCreate: SyncSourceTestConnectionCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncSourceTestConnection>(
      {url: `/teams/${teamName}/sync-source-test-connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncSourceTestConnectionCreate, signal
    },
      );
    }
  


export const getCreateSyncSourceTestConnectionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncSourceTestConnection>>, TError,{teamName: string;data: SyncSourceTestConnectionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSyncSourceTestConnection>>, TError,{teamName: string;data: SyncSourceTestConnectionCreate}, TContext> => {

const mutationKey = ['createSyncSourceTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSyncSourceTestConnection>>, {teamName: string;data: SyncSourceTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createSyncSourceTestConnection(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSyncSourceTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof createSyncSourceTestConnection>>>
    export type CreateSyncSourceTestConnectionMutationBody = SyncSourceTestConnectionCreate
    export type CreateSyncSourceTestConnectionMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useCreateSyncSourceTestConnection = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncSourceTestConnection>>, TError,{teamName: string;data: SyncSourceTestConnectionCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSyncSourceTestConnection>>,
        TError,
        {teamName: string;data: SyncSourceTestConnectionCreate},
        TContext
      > => {

      const mutationOptions = getCreateSyncSourceTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a sync source test connection.
 */
export const getSyncSourceTestConnection = (
    teamName: string,
    syncSourceTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncSourceTestConnection>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncSourceTestConnectionQueryKey = (teamName: string,
    syncSourceTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`] as const;
    }

    
export const getGetSyncSourceTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getSyncSourceTestConnection>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncSourceTestConnection>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncSourceTestConnectionQueryKey(teamName,syncSourceTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncSourceTestConnection>>> = ({ signal }) => getSyncSourceTestConnection(teamName,syncSourceTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncSourceTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncSourceTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncSourceTestConnection>>>
export type GetSyncSourceTestConnectionQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetSyncSourceTestConnection<TData = Awaited<ReturnType<typeof getSyncSourceTestConnection>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncSourceTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncSourceTestConnection>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncSourceTestConnectionQueryOptions(teamName,syncSourceTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a sync source test connection.
 */
export const updateSyncTestConnectionForSyncSource = (
    teamName: string,
    syncSourceTestConnectionId: string,
    updateSyncTestConnectionForSyncSourceBody: UpdateSyncTestConnectionForSyncSourceBody,
 ) => {
      
      
      return customFetch<SyncSourceTestConnection>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSyncTestConnectionForSyncSourceBody
    },
      );
    }
  


export const getUpdateSyncTestConnectionForSyncSourceMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: UpdateSyncTestConnectionForSyncSourceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: UpdateSyncTestConnectionForSyncSourceBody}, TContext> => {

const mutationKey = ['updateSyncTestConnectionForSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncSource>>, {teamName: string;syncSourceTestConnectionId: string;data: UpdateSyncTestConnectionForSyncSourceBody}> = (props) => {
          const {teamName,syncSourceTestConnectionId,data} = props ?? {};

          return  updateSyncTestConnectionForSyncSource(teamName,syncSourceTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSyncTestConnectionForSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncSource>>>
    export type UpdateSyncTestConnectionForSyncSourceMutationBody = UpdateSyncTestConnectionForSyncSourceBody
    export type UpdateSyncTestConnectionForSyncSourceMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSyncTestConnectionForSyncSource = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncSource>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: UpdateSyncTestConnectionForSyncSourceBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSyncTestConnectionForSyncSource>>,
        TError,
        {teamName: string;syncSourceTestConnectionId: string;data: UpdateSyncTestConnectionForSyncSourceBody},
        TContext
      > => {

      const mutationOptions = getUpdateSyncTestConnectionForSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Promote a sync source test connection to a sync source.
 */
export const promoteSyncSourceTestConnection = (
    teamName: string,
    syncSourceTestConnectionId: string,
    promoteSyncSourceTestConnection: PromoteSyncSourceTestConnection,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncSource>(
      {url: `/teams/${teamName}/sync-source-test-connections/${syncSourceTestConnectionId}/promote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promoteSyncSourceTestConnection, signal
    },
      );
    }
  


export const getPromoteSyncSourceTestConnectionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PromoteSyncSourceTestConnection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof promoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PromoteSyncSourceTestConnection}, TContext> => {

const mutationKey = ['promoteSyncSourceTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteSyncSourceTestConnection>>, {teamName: string;syncSourceTestConnectionId: string;data: PromoteSyncSourceTestConnection}> = (props) => {
          const {teamName,syncSourceTestConnectionId,data} = props ?? {};

          return  promoteSyncSourceTestConnection(teamName,syncSourceTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PromoteSyncSourceTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof promoteSyncSourceTestConnection>>>
    export type PromoteSyncSourceTestConnectionMutationBody = PromoteSyncSourceTestConnection
    export type PromoteSyncSourceTestConnectionMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const usePromoteSyncSourceTestConnection = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteSyncSourceTestConnection>>, TError,{teamName: string;syncSourceTestConnectionId: string;data: PromoteSyncSourceTestConnection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof promoteSyncSourceTestConnection>>,
        TError,
        {teamName: string;syncSourceTestConnectionId: string;data: PromoteSyncSourceTestConnection},
        TContext
      > => {

      const mutationOptions = getPromoteSyncSourceTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Create a test destination connection.
 */
export const createSyncDestinationTestConnection = (
    teamName: string,
    syncDestinationTestConnectionCreate: SyncDestinationTestConnectionCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncDestinationTestConnection>(
      {url: `/teams/${teamName}/sync-destination-test-connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncDestinationTestConnectionCreate, signal
    },
      );
    }
  


export const getCreateSyncDestinationTestConnectionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncDestinationTestConnection>>, TError,{teamName: string;data: SyncDestinationTestConnectionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSyncDestinationTestConnection>>, TError,{teamName: string;data: SyncDestinationTestConnectionCreate}, TContext> => {

const mutationKey = ['createSyncDestinationTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSyncDestinationTestConnection>>, {teamName: string;data: SyncDestinationTestConnectionCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createSyncDestinationTestConnection(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof createSyncDestinationTestConnection>>>
    export type CreateSyncDestinationTestConnectionMutationBody = SyncDestinationTestConnectionCreate
    export type CreateSyncDestinationTestConnectionMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useCreateSyncDestinationTestConnection = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncDestinationTestConnection>>, TError,{teamName: string;data: SyncDestinationTestConnectionCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSyncDestinationTestConnection>>,
        TError,
        {teamName: string;data: SyncDestinationTestConnectionCreate},
        TContext
      > => {

      const mutationOptions = getCreateSyncDestinationTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a sync destination test connection.
 */
export const getSyncDestinationTestConnection = (
    teamName: string,
    syncDestinationTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncDestinationTestConnection>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncDestinationTestConnectionQueryKey = (teamName: string,
    syncDestinationTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`] as const;
    }

    
export const getGetSyncDestinationTestConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getSyncDestinationTestConnection>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncDestinationTestConnection>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncDestinationTestConnectionQueryKey(teamName,syncDestinationTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncDestinationTestConnection>>> = ({ signal }) => getSyncDestinationTestConnection(teamName,syncDestinationTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncDestinationTestConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncDestinationTestConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncDestinationTestConnection>>>
export type GetSyncDestinationTestConnectionQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetSyncDestinationTestConnection<TData = Awaited<ReturnType<typeof getSyncDestinationTestConnection>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncDestinationTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncDestinationTestConnection>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncDestinationTestConnectionQueryOptions(teamName,syncDestinationTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a sync destination test connection.
 */
export const updateSyncTestConnectionForSyncDestination = (
    teamName: string,
    syncDestinationTestConnectionId: string,
    updateSyncTestConnectionForSyncDestinationBody: UpdateSyncTestConnectionForSyncDestinationBody,
 ) => {
      
      
      return customFetch<SyncDestinationTestConnection>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSyncTestConnectionForSyncDestinationBody
    },
      );
    }
  


export const getUpdateSyncTestConnectionForSyncDestinationMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: UpdateSyncTestConnectionForSyncDestinationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: UpdateSyncTestConnectionForSyncDestinationBody}, TContext> => {

const mutationKey = ['updateSyncTestConnectionForSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncDestination>>, {teamName: string;syncDestinationTestConnectionId: string;data: UpdateSyncTestConnectionForSyncDestinationBody}> = (props) => {
          const {teamName,syncDestinationTestConnectionId,data} = props ?? {};

          return  updateSyncTestConnectionForSyncDestination(teamName,syncDestinationTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSyncTestConnectionForSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncDestination>>>
    export type UpdateSyncTestConnectionForSyncDestinationMutationBody = UpdateSyncTestConnectionForSyncDestinationBody
    export type UpdateSyncTestConnectionForSyncDestinationMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSyncTestConnectionForSyncDestination = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncTestConnectionForSyncDestination>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: UpdateSyncTestConnectionForSyncDestinationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSyncTestConnectionForSyncDestination>>,
        TError,
        {teamName: string;syncDestinationTestConnectionId: string;data: UpdateSyncTestConnectionForSyncDestinationBody},
        TContext
      > => {

      const mutationOptions = getUpdateSyncTestConnectionForSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Promote a sync destination test connection to a sync destination.
 */
export const promoteSyncDestinationTestConnection = (
    teamName: string,
    syncDestinationTestConnectionId: string,
    promoteSyncDestinationTestConnection: PromoteSyncDestinationTestConnection,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncDestination>(
      {url: `/teams/${teamName}/sync-destination-test-connections/${syncDestinationTestConnectionId}/promote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promoteSyncDestinationTestConnection, signal
    },
      );
    }
  


export const getPromoteSyncDestinationTestConnectionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PromoteSyncDestinationTestConnection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof promoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PromoteSyncDestinationTestConnection}, TContext> => {

const mutationKey = ['promoteSyncDestinationTestConnection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteSyncDestinationTestConnection>>, {teamName: string;syncDestinationTestConnectionId: string;data: PromoteSyncDestinationTestConnection}> = (props) => {
          const {teamName,syncDestinationTestConnectionId,data} = props ?? {};

          return  promoteSyncDestinationTestConnection(teamName,syncDestinationTestConnectionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PromoteSyncDestinationTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof promoteSyncDestinationTestConnection>>>
    export type PromoteSyncDestinationTestConnectionMutationBody = PromoteSyncDestinationTestConnection
    export type PromoteSyncDestinationTestConnectionMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const usePromoteSyncDestinationTestConnection = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteSyncDestinationTestConnection>>, TError,{teamName: string;syncDestinationTestConnectionId: string;data: PromoteSyncDestinationTestConnection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof promoteSyncDestinationTestConnection>>,
        TError,
        {teamName: string;syncDestinationTestConnectionId: string;data: PromoteSyncDestinationTestConnection},
        TContext
      > => {

      const mutationOptions = getPromoteSyncDestinationTestConnectionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all sync source definitions.
 */
export const listSyncSources = (
    teamName: string,
    params?: ListSyncSourcesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSyncSources200>(
      {url: `/teams/${teamName}/sync-sources`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSyncSourcesQueryKey = (teamName: string,
    params?: ListSyncSourcesParams,) => {
    return [`/teams/${teamName}/sync-sources`, ...(params ? [params]: [])] as const;
    }

    
export const getListSyncSourcesQueryOptions = <TData = Awaited<ReturnType<typeof listSyncSources>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListSyncSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncSources>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncSourcesQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncSources>>> = ({ signal }) => listSyncSources(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncSources>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncSources>>>
export type ListSyncSourcesQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListSyncSources<TData = Awaited<ReturnType<typeof listSyncSources>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListSyncSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncSources>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncSourcesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a single sync source definition.
 */
export const getSyncSource = (
    teamName: string,
    syncSourceName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncSource>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncSourceQueryKey = (teamName: string,
    syncSourceName: string,) => {
    return [`/teams/${teamName}/sync-sources/${syncSourceName}`] as const;
    }

    
export const getGetSyncSourceQueryOptions = <TData = Awaited<ReturnType<typeof getSyncSource>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncSourceName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncSource>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncSourceQueryKey(teamName,syncSourceName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncSource>>> = ({ signal }) => getSyncSource(teamName,syncSourceName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncSource>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncSourceQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncSource>>>
export type GetSyncSourceQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetSyncSource<TData = Awaited<ReturnType<typeof getSyncSource>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncSourceName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncSource>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncSourceQueryOptions(teamName,syncSourceName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync Source definition.
 */
export const updateSyncSource = (
    teamName: string,
    syncSourceName: string,
    syncSourceUpdate: SyncSourceUpdate,
 ) => {
      
      
      return customFetch<SyncSource>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: syncSourceUpdate
    },
      );
    }
  


export const getUpdateSyncSourceMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: SyncSourceUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: SyncSourceUpdate}, TContext> => {

const mutationKey = ['updateSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSyncSource>>, {teamName: string;syncSourceName: string;data: SyncSourceUpdate}> = (props) => {
          const {teamName,syncSourceName,data} = props ?? {};

          return  updateSyncSource(teamName,syncSourceName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateSyncSource>>>
    export type UpdateSyncSourceMutationBody = SyncSourceUpdate
    export type UpdateSyncSourceMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSyncSource = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncSource>>, TError,{teamName: string;syncSourceName: string;data: SyncSourceUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string;data: SyncSourceUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a Sync Source definition. Any syncs relying on this source must be deleted first.
 */
export const deleteSyncSource = (
    teamName: string,
    syncSourceName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSyncSourceMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext> => {

const mutationKey = ['deleteSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSyncSource>>, {teamName: string;syncSourceName: string}> = (props) => {
          const {teamName,syncSourceName} = props ?? {};

          return  deleteSyncSource(teamName,syncSourceName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSyncSource>>>
    
    export type DeleteSyncSourceMutationError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteSyncSource = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSyncSource>>, TError,{teamName: string;syncSourceName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSyncSource>>,
        TError,
        {teamName: string;syncSourceName: string},
        TContext
      > => {

      const mutationOptions = getDeleteSyncSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get test connection details for sync source.
 */
export const getTestConnectionForSyncSource = (
    teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncTestConnection>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}/test-connections/${syncTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTestConnectionForSyncSourceQueryKey = (teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-sources/${syncSourceName}/test-connections/${syncTestConnectionId}`] as const;
    }

    
export const getGetTestConnectionForSyncSourceQueryOptions = <TData = Awaited<ReturnType<typeof getTestConnectionForSyncSource>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionForSyncSource>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestConnectionForSyncSourceQueryKey(teamName,syncSourceName,syncTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestConnectionForSyncSource>>> = ({ signal }) => getTestConnectionForSyncSource(teamName,syncSourceName,syncTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionForSyncSource>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTestConnectionForSyncSourceQueryResult = NonNullable<Awaited<ReturnType<typeof getTestConnectionForSyncSource>>>
export type GetTestConnectionForSyncSourceQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetTestConnectionForSyncSource<TData = Awaited<ReturnType<typeof getTestConnectionForSyncSource>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncSourceName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionForSyncSource>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTestConnectionForSyncSourceQueryOptions(teamName,syncSourceName,syncTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all Syncs for a given sync source.
 */
export const listSyncSourceSyncs = (
    teamName: string,
    syncSourceName: string,
    params?: ListSyncSourceSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSyncSourceSyncs200>(
      {url: `/teams/${teamName}/sync-sources/${syncSourceName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSyncSourceSyncsQueryKey = (teamName: string,
    syncSourceName: string,
    params?: ListSyncSourceSyncsParams,) => {
    return [`/teams/${teamName}/sync-sources/${syncSourceName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getListSyncSourceSyncsQueryOptions = <TData = Awaited<ReturnType<typeof listSyncSourceSyncs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncSourceName: string,
    params?: ListSyncSourceSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncSourceSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncSourceSyncsQueryKey(teamName,syncSourceName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncSourceSyncs>>> = ({ signal }) => listSyncSourceSyncs(teamName,syncSourceName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncSourceName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncSourceSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncSourceSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncSourceSyncs>>>
export type ListSyncSourceSyncsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListSyncSourceSyncs<TData = Awaited<ReturnType<typeof listSyncSourceSyncs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncSourceName: string,
    params?: ListSyncSourceSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncSourceSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncSourceSyncsQueryOptions(teamName,syncSourceName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all sync destination definitions.
 */
export const listSyncDestinations = (
    teamName: string,
    params?: ListSyncDestinationsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSyncDestinations200>(
      {url: `/teams/${teamName}/sync-destinations`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSyncDestinationsQueryKey = (teamName: string,
    params?: ListSyncDestinationsParams,) => {
    return [`/teams/${teamName}/sync-destinations`, ...(params ? [params]: [])] as const;
    }

    
export const getListSyncDestinationsQueryOptions = <TData = Awaited<ReturnType<typeof listSyncDestinations>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncDestinations>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncDestinationsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncDestinations>>> = ({ signal }) => listSyncDestinations(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncDestinations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncDestinationsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncDestinations>>>
export type ListSyncDestinationsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListSyncDestinations<TData = Awaited<ReturnType<typeof listSyncDestinations>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListSyncDestinationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncDestinations>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncDestinationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a single sync destination definition.
 */
export const getSyncDestination = (
    teamName: string,
    syncDestinationName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncDestination>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,) => {
    return [`/teams/${teamName}/sync-destinations/${syncDestinationName}`] as const;
    }

    
export const getGetSyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof getSyncDestination>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncDestination>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncDestinationQueryKey(teamName,syncDestinationName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncDestination>>> = ({ signal }) => getSyncDestination(teamName,syncDestinationName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncDestination>>>
export type GetSyncDestinationQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetSyncDestination<TData = Awaited<ReturnType<typeof getSyncDestination>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncDestinationName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncDestination>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncDestinationQueryOptions(teamName,syncDestinationName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync Destination definition.
 */
export const updateSyncDestination = (
    teamName: string,
    syncDestinationName: string,
    syncDestinationUpdate: SyncDestinationUpdate,
 ) => {
      
      
      return customFetch<SyncDestination>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: syncDestinationUpdate
    },
      );
    }
  


export const getUpdateSyncDestinationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: SyncDestinationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: SyncDestinationUpdate}, TContext> => {

const mutationKey = ['updateSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSyncDestination>>, {teamName: string;syncDestinationName: string;data: SyncDestinationUpdate}> = (props) => {
          const {teamName,syncDestinationName,data} = props ?? {};

          return  updateSyncDestination(teamName,syncDestinationName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof updateSyncDestination>>>
    export type UpdateSyncDestinationMutationBody = SyncDestinationUpdate
    export type UpdateSyncDestinationMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSyncDestination = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncDestination>>, TError,{teamName: string;syncDestinationName: string;data: SyncDestinationUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string;data: SyncDestinationUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete a Sync Destination definition. Any syncs relying on this destination must be deleted first.
 */
export const deleteSyncDestination = (
    teamName: string,
    syncDestinationName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSyncDestinationMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext> => {

const mutationKey = ['deleteSyncDestination'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSyncDestination>>, {teamName: string;syncDestinationName: string}> = (props) => {
          const {teamName,syncDestinationName} = props ?? {};

          return  deleteSyncDestination(teamName,syncDestinationName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSyncDestinationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSyncDestination>>>
    
    export type DeleteSyncDestinationMutationError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteSyncDestination = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSyncDestination>>, TError,{teamName: string;syncDestinationName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSyncDestination>>,
        TError,
        {teamName: string;syncDestinationName: string},
        TContext
      > => {

      const mutationOptions = getDeleteSyncDestinationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get test connection details for sync destination.
 */
export const getTestConnectionForSyncDestination = (
    teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncTestConnection>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}/test-connections/${syncTestConnectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTestConnectionForSyncDestinationQueryKey = (teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string,) => {
    return [`/teams/${teamName}/sync-destinations/${syncDestinationName}/test-connections/${syncTestConnectionId}`] as const;
    }

    
export const getGetTestConnectionForSyncDestinationQueryOptions = <TData = Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestConnectionForSyncDestinationQueryKey(teamName,syncDestinationName,syncTestConnectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>> = ({ signal }) => getTestConnectionForSyncDestination(teamName,syncDestinationName,syncTestConnectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName && syncTestConnectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTestConnectionForSyncDestinationQueryResult = NonNullable<Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>>
export type GetTestConnectionForSyncDestinationQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetTestConnectionForSyncDestination<TData = Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncDestinationName: string,
    syncTestConnectionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionForSyncDestination>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTestConnectionForSyncDestinationQueryOptions(teamName,syncDestinationName,syncTestConnectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all Syncs for a given sync destination.
 */
export const listSyncDestinationSyncs = (
    teamName: string,
    syncDestinationName: string,
    params?: ListSyncDestinationSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSyncDestinationSyncs200>(
      {url: `/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSyncDestinationSyncsQueryKey = (teamName: string,
    syncDestinationName: string,
    params?: ListSyncDestinationSyncsParams,) => {
    return [`/teams/${teamName}/sync-destinations/${syncDestinationName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getListSyncDestinationSyncsQueryOptions = <TData = Awaited<ReturnType<typeof listSyncDestinationSyncs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncDestinationName: string,
    params?: ListSyncDestinationSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncDestinationSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncDestinationSyncsQueryKey(teamName,syncDestinationName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncDestinationSyncs>>> = ({ signal }) => listSyncDestinationSyncs(teamName,syncDestinationName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncDestinationName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncDestinationSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncDestinationSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncDestinationSyncs>>>
export type ListSyncDestinationSyncsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListSyncDestinationSyncs<TData = Awaited<ReturnType<typeof listSyncDestinationSyncs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncDestinationName: string,
    params?: ListSyncDestinationSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncDestinationSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncDestinationSyncsQueryOptions(teamName,syncDestinationName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List all Syncs.
 */
export const listSyncs = (
    teamName: string,
    params?: ListSyncsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSyncs200>(
      {url: `/teams/${teamName}/syncs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSyncsQueryKey = (teamName: string,
    params?: ListSyncsParams,) => {
    return [`/teams/${teamName}/syncs`, ...(params ? [params]: [])] as const;
    }

    
export const getListSyncsQueryOptions = <TData = Awaited<ReturnType<typeof listSyncs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncs>>> = ({ signal }) => listSyncs(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncs>>>
export type ListSyncsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListSyncs<TData = Awaited<ReturnType<typeof listSyncs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListSyncsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new Sync definition. Sync runs can be scheduled automatically, or triggered manually after sync is created.
 */
export const createSync = (
    teamName: string,
    syncCreate: SyncCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Sync>(
      {url: `/teams/${teamName}/syncs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncCreate, signal
    },
      );
    }
  


export const getCreateSyncMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSync>>, TError,{teamName: string;data: SyncCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSync>>, TError,{teamName: string;data: SyncCreate}, TContext> => {

const mutationKey = ['createSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSync>>, {teamName: string;data: SyncCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createSync(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSyncMutationResult = NonNullable<Awaited<ReturnType<typeof createSync>>>
    export type CreateSyncMutationBody = SyncCreate
    export type CreateSyncMutationError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateSync = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSync>>, TError,{teamName: string;data: SyncCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSync>>,
        TError,
        {teamName: string;data: SyncCreate},
        TContext
      > => {

      const mutationOptions = getCreateSyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a Sync
 */
export const getSync = (
    teamName: string,
    syncName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Sync>(
      {url: `/teams/${teamName}/syncs/${syncName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncQueryKey = (teamName: string,
    syncName: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}`] as const;
    }

    
export const getGetSyncQueryOptions = <TData = Awaited<ReturnType<typeof getSync>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSync>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncQueryKey(teamName,syncName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSync>>> = ({ signal }) => getSync(teamName,syncName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSync>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncQueryResult = NonNullable<Awaited<ReturnType<typeof getSync>>>
export type GetSyncQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetSync<TData = Awaited<ReturnType<typeof getSync>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSync>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncQueryOptions(teamName,syncName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a Sync
 */
export const updateSync = (
    teamName: string,
    syncName: string,
    syncUpdate: SyncUpdate,
 ) => {
      
      
      return customFetch<Sync>(
      {url: `/teams/${teamName}/syncs/${syncName}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: syncUpdate
    },
      );
    }
  


export const getUpdateSyncMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSync>>, TError,{teamName: string;syncName: string;data: SyncUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSync>>, TError,{teamName: string;syncName: string;data: SyncUpdate}, TContext> => {

const mutationKey = ['updateSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSync>>, {teamName: string;syncName: string;data: SyncUpdate}> = (props) => {
          const {teamName,syncName,data} = props ?? {};

          return  updateSync(teamName,syncName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSyncMutationResult = NonNullable<Awaited<ReturnType<typeof updateSync>>>
    export type UpdateSyncMutationBody = SyncUpdate
    export type UpdateSyncMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSync = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSync>>, TError,{teamName: string;syncName: string;data: SyncUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSync>>,
        TError,
        {teamName: string;syncName: string;data: SyncUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateSyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Delete Sync. This will delete Sync configuration and all associated sync runs, but will not delete the associated source and destination(s). These will need to be deleted separately.
 */
export const deleteSync = (
    teamName: string,
    syncName: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/syncs/${syncName}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSyncMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSync>>, TError,{teamName: string;syncName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSync>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['deleteSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSync>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  deleteSync(teamName,syncName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSyncMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSync>>>
    
    export type DeleteSyncMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteSync = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSync>>, TError,{teamName: string;syncName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSync>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {

      const mutationOptions = getDeleteSyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all Sync Runs.
 */
export const listSyncRuns = (
    teamName: string,
    syncName: string,
    params?: ListSyncRunsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListSyncRuns200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListSyncRunsQueryKey = (teamName: string,
    syncName: string,
    params?: ListSyncRunsParams,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs`, ...(params ? [params]: [])] as const;
    }

    
export const getListSyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof listSyncRuns>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncName: string,
    params?: ListSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncRuns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSyncRunsQueryKey(teamName,syncName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSyncRuns>>> = ({ signal }) => listSyncRuns(teamName,syncName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSyncRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listSyncRuns>>>
export type ListSyncRunsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListSyncRuns<TData = Awaited<ReturnType<typeof listSyncRuns>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncName: string,
    params?: ListSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSyncRuns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSyncRunsQueryOptions(teamName,syncName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new SyncRun. This will trigger a manual job run.
 */
export const createSyncRun = (
    teamName: string,
    syncName: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncRun>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs`, method: 'POST', signal
    },
      );
    }
  


export const getCreateSyncRunMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncRun>>, TError,{teamName: string;syncName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSyncRun>>, TError,{teamName: string;syncName: string}, TContext> => {

const mutationKey = ['createSyncRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSyncRun>>, {teamName: string;syncName: string}> = (props) => {
          const {teamName,syncName} = props ?? {};

          return  createSyncRun(teamName,syncName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof createSyncRun>>>
    
    export type CreateSyncRunMutationError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateSyncRun = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncRun>>, TError,{teamName: string;syncName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSyncRun>>,
        TError,
        {teamName: string;syncName: string},
        TContext
      > => {

      const mutationOptions = getCreateSyncRunMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a Sync Run.
 */
export const getSyncRun = (
    teamName: string,
    syncName: string,
    syncRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<SyncRunDetails>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncRunQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`] as const;
    }

    
export const getGetSyncRunQueryOptions = <TData = Awaited<ReturnType<typeof getSyncRun>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRun>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncRunQueryKey(teamName,syncName,syncRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncRun>>> = ({ signal }) => getSyncRun(teamName,syncName,syncRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncRun>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncRunQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncRun>>>
export type GetSyncRunQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetSyncRun<TData = Awaited<ReturnType<typeof getSyncRun>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRun>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncRunQueryOptions(teamName,syncName,syncRunId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a SyncRun
 */
export const updateSyncRun = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    updateSyncRunBody: UpdateSyncRunBody,
 ) => {
      
      
      return customFetch<SyncRun>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSyncRunBody
    },
      );
    }
  


export const getUpdateSyncRunMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: UpdateSyncRunBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: UpdateSyncRunBody}, TContext> => {

const mutationKey = ['updateSyncRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSyncRun>>, {teamName: string;syncName: string;syncRunId: string;data: UpdateSyncRunBody}> = (props) => {
          const {teamName,syncName,syncRunId,data} = props ?? {};

          return  updateSyncRun(teamName,syncName,syncRunId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSyncRunMutationResult = NonNullable<Awaited<ReturnType<typeof updateSyncRun>>>
    export type UpdateSyncRunMutationBody = UpdateSyncRunBody
    export type UpdateSyncRunMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSyncRun = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSyncRun>>, TError,{teamName: string;syncName: string;syncRunId: string;data: UpdateSyncRunBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSyncRun>>,
        TError,
        {teamName: string;syncName: string;syncRunId: string;data: UpdateSyncRunBody},
        TContext
      > => {

      const mutationOptions = getUpdateSyncRunMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Create a new sync run progress update.
 */
export const createSyncRunProgress = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    createSyncRunProgressBody: CreateSyncRunProgressBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/progress`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSyncRunProgressBody, signal
    },
      );
    }
  


export const getCreateSyncRunProgressMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: CreateSyncRunProgressBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: CreateSyncRunProgressBody}, TContext> => {

const mutationKey = ['createSyncRunProgress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSyncRunProgress>>, {teamName: string;syncName: string;syncRunId: string;data: CreateSyncRunProgressBody}> = (props) => {
          const {teamName,syncName,syncRunId,data} = props ?? {};

          return  createSyncRunProgress(teamName,syncName,syncRunId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSyncRunProgressMutationResult = NonNullable<Awaited<ReturnType<typeof createSyncRunProgress>>>
    export type CreateSyncRunProgressMutationBody = CreateSyncRunProgressBody
    export type CreateSyncRunProgressMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateSyncRunProgress = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSyncRunProgress>>, TError,{teamName: string;syncName: string;syncRunId: string;data: CreateSyncRunProgressBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSyncRunProgress>>,
        TError,
        {teamName: string;syncName: string;syncRunId: string;data: CreateSyncRunProgressBody},
        TContext
      > => {

      const mutationOptions = getCreateSyncRunProgressMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get logs for a sync run.
 */
export const getSyncRunLogs = (
    teamName: string,
    syncName: string,
    syncRunId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetSyncRunLogs200One | string | void>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncRunLogsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/logs`] as const;
    }

    
export const getGetSyncRunLogsQueryOptions = <TData = Awaited<ReturnType<typeof getSyncRunLogs>>, TError = void | BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRunLogs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncRunLogsQueryKey(teamName,syncName,syncRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncRunLogs>>> = ({ signal }) => getSyncRunLogs(teamName,syncName,syncRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncRunLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncRunLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncRunLogs>>>
export type GetSyncRunLogsQueryError = void | BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetSyncRunLogs<TData = Awaited<ReturnType<typeof getSyncRunLogs>>, TError = void | BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRunLogs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncRunLogsQueryOptions(teamName,syncName,syncRunId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector identity for a sync run.
 */
export const getSyncRunConnectorIdentity = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetSyncRunConnectorIdentity200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/identity`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncRunConnectorIdentityQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/identity`] as const;
    }

    
export const getGetSyncRunConnectorIdentityQueryOptions = <TData = Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncRunConnectorIdentityQueryKey(teamName,syncName,syncRunId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>> = ({ signal }) => getSyncRunConnectorIdentity(teamName,syncName,syncRunId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncRunConnectorIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>>
export type GetSyncRunConnectorIdentityQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetSyncRunConnectorIdentity<TData = Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRunConnectorIdentity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncRunConnectorIdentityQueryOptions(teamName,syncName,syncRunId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector credentials for a sync run.
 */
export const getSyncRunConnectorCredentials = (
    teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetSyncRunConnectorCredentials200>(
      {url: `/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/credentials`, method: 'GET', signal
    },
      );
    }
  

export const getGetSyncRunConnectorCredentialsQueryKey = (teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/${syncName}/runs/${syncRunId}/connector/${connectorId}/credentials`] as const;
    }

    
export const getGetSyncRunConnectorCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncRunConnectorCredentialsQueryKey(teamName,syncName,syncRunId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>> = ({ signal }) => getSyncRunConnectorCredentials(teamName,syncName,syncRunId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncName && syncRunId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSyncRunConnectorCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>>
export type GetSyncRunConnectorCredentialsQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetSyncRunConnectorCredentials<TData = Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    syncName: string,
    syncRunId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSyncRunConnectorCredentials>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSyncRunConnectorCredentialsQueryOptions(teamName,syncName,syncRunId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector identity for a test connection.
 */
export const getTestConnectionConnectorIdentity = (
    teamName: string,
    syncTestConnectionId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetTestConnectionConnectorIdentity200>(
      {url: `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/identity`, method: 'GET', signal
    },
      );
    }
  

export const getGetTestConnectionConnectorIdentityQueryKey = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/identity`] as const;
    }

    
export const getGetTestConnectionConnectorIdentityQueryOptions = <TData = Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestConnectionConnectorIdentityQueryKey(teamName,syncTestConnectionId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>> = ({ signal }) => getTestConnectionConnectorIdentity(teamName,syncTestConnectionId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTestConnectionId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTestConnectionConnectorIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>>
export type GetTestConnectionConnectorIdentityQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetTestConnectionConnectorIdentity<TData = Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionConnectorIdentity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTestConnectionConnectorIdentityQueryOptions(teamName,syncTestConnectionId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get connector credentials for a test connection
 */
export const getTestConnectionConnectorCredentials = (
    teamName: string,
    syncTestConnectionId: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetTestConnectionConnectorCredentials200>(
      {url: `/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/credentials`, method: 'GET', signal
    },
      );
    }
  

export const getGetTestConnectionConnectorCredentialsQueryKey = (teamName: string,
    syncTestConnectionId: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/syncs/test-connections/${syncTestConnectionId}/connector/${connectorId}/credentials`] as const;
    }

    
export const getGetTestConnectionConnectorCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestConnectionConnectorCredentialsQueryKey(teamName,syncTestConnectionId,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>> = ({ signal }) => getTestConnectionConnectorCredentials(teamName,syncTestConnectionId,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && syncTestConnectionId && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTestConnectionConnectorCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>>
export type GetTestConnectionConnectorCredentialsQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetTestConnectionConnectorCredentials<TData = Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    syncTestConnectionId: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTestConnectionConnectorCredentials>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTestConnectionConnectorCredentialsQueryOptions(teamName,syncTestConnectionId,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a paginated list of managed databases
 */
export const getManagedDatabases = (
    teamName: string,
    params?: GetManagedDatabasesParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetManagedDatabases200>(
      {url: `/teams/${teamName}/managed-databases`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetManagedDatabasesQueryKey = (teamName: string,
    params?: GetManagedDatabasesParams,) => {
    return [`/teams/${teamName}/managed-databases`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManagedDatabasesQueryOptions = <TData = Awaited<ReturnType<typeof getManagedDatabases>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: GetManagedDatabasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabases>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManagedDatabasesQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManagedDatabases>>> = ({ signal }) => getManagedDatabases(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabases>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManagedDatabasesQueryResult = NonNullable<Awaited<ReturnType<typeof getManagedDatabases>>>
export type GetManagedDatabasesQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetManagedDatabases<TData = Awaited<ReturnType<typeof getManagedDatabases>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetManagedDatabasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabases>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetManagedDatabasesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new managed database
 */
export const createManagedDatabase = (
    teamName: string,
    managedDatabaseCreate: ManagedDatabaseCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ManagedDatabase>(
      {url: `/teams/${teamName}/managed-databases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: managedDatabaseCreate, signal
    },
      );
    }
  


export const getCreateManagedDatabaseMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createManagedDatabase>>, TError,{teamName: string;data: ManagedDatabaseCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createManagedDatabase>>, TError,{teamName: string;data: ManagedDatabaseCreate}, TContext> => {

const mutationKey = ['createManagedDatabase'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createManagedDatabase>>, {teamName: string;data: ManagedDatabaseCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createManagedDatabase(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateManagedDatabaseMutationResult = NonNullable<Awaited<ReturnType<typeof createManagedDatabase>>>
    export type CreateManagedDatabaseMutationBody = ManagedDatabaseCreate
    export type CreateManagedDatabaseMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateManagedDatabase = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createManagedDatabase>>, TError,{teamName: string;data: ManagedDatabaseCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createManagedDatabase>>,
        TError,
        {teamName: string;data: ManagedDatabaseCreate},
        TContext
      > => {

      const mutationOptions = getCreateManagedDatabaseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a single managed database.
 */
export const getManagedDatabase = (
    teamName: string,
    managedDatabaseId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ManagedDatabase>(
      {url: `/teams/${teamName}/managed-databases/${managedDatabaseId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetManagedDatabaseQueryKey = (teamName: string,
    managedDatabaseId: string,) => {
    return [`/teams/${teamName}/managed-databases/${managedDatabaseId}`] as const;
    }

    
export const getGetManagedDatabaseQueryOptions = <TData = Awaited<ReturnType<typeof getManagedDatabase>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    managedDatabaseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabase>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManagedDatabaseQueryKey(teamName,managedDatabaseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManagedDatabase>>> = ({ signal }) => getManagedDatabase(teamName,managedDatabaseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && managedDatabaseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabase>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManagedDatabaseQueryResult = NonNullable<Awaited<ReturnType<typeof getManagedDatabase>>>
export type GetManagedDatabaseQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetManagedDatabase<TData = Awaited<ReturnType<typeof getManagedDatabase>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    managedDatabaseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabase>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetManagedDatabaseQueryOptions(teamName,managedDatabaseId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete this managed database. Any syncs relying on this database must be deleted first.
 */
export const deleteManagedDatabase = (
    teamName: string,
    managedDatabaseId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/managed-databases/${managedDatabaseId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteManagedDatabaseMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteManagedDatabase>>, TError,{teamName: string;managedDatabaseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteManagedDatabase>>, TError,{teamName: string;managedDatabaseId: string}, TContext> => {

const mutationKey = ['deleteManagedDatabase'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteManagedDatabase>>, {teamName: string;managedDatabaseId: string}> = (props) => {
          const {teamName,managedDatabaseId} = props ?? {};

          return  deleteManagedDatabase(teamName,managedDatabaseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteManagedDatabaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteManagedDatabase>>>
    
    export type DeleteManagedDatabaseMutationError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteManagedDatabase = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteManagedDatabase>>, TError,{teamName: string;managedDatabaseId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteManagedDatabase>>,
        TError,
        {teamName: string;managedDatabaseId: string},
        TContext
      > => {

      const mutationOptions = getDeleteManagedDatabaseMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * List all configured connectors
 */
export const listConnectors = (
    teamName: string,
    params?: ListConnectorsParams,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ListConnectors200>(
      {url: `/teams/${teamName}/connectors`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListConnectorsQueryKey = (teamName: string,
    params?: ListConnectorsParams,) => {
    return [`/teams/${teamName}/connectors`, ...(params ? [params]: [])] as const;
    }

    
export const getListConnectorsQueryOptions = <TData = Awaited<ReturnType<typeof listConnectors>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListConnectorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConnectors>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectorsQueryKey(teamName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnectors>>> = ({ signal }) => listConnectors(teamName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnectors>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConnectorsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnectors>>>
export type ListConnectorsQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListConnectors<TData = Awaited<ReturnType<typeof listConnectors>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListConnectorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConnectors>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConnectorsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create new connector
 */
export const createConnector = (
    teamName: string,
    connectorCreate: ConnectorCreate,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Connector>(
      {url: `/teams/${teamName}/connectors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectorCreate, signal
    },
      );
    }
  


export const getCreateConnectorMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConnector>>, TError,{teamName: string;data: ConnectorCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createConnector>>, TError,{teamName: string;data: ConnectorCreate}, TContext> => {

const mutationKey = ['createConnector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConnector>>, {teamName: string;data: ConnectorCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createConnector(teamName,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof createConnector>>>
    export type CreateConnectorMutationBody = ConnectorCreate
    export type CreateConnectorMutationError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateConnector = <TError = BadRequestResponse | RequiresAuthenticationResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConnector>>, TError,{teamName: string;data: ConnectorCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConnector>>,
        TError,
        {teamName: string;data: ConnectorCreate},
        TContext
      > => {

      const mutationOptions = getCreateConnectorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get a configured connector
 */
export const getConnector = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<Connector>(
      {url: `/teams/${teamName}/connectors/${connectorId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetConnectorQueryKey = (teamName: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/connectors/${connectorId}`] as const;
    }

    
export const getGetConnectorQueryOptions = <TData = Awaited<ReturnType<typeof getConnector>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnector>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorQueryKey(teamName,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnector>>> = ({ signal }) => getConnector(teamName,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnector>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectorQueryResult = NonNullable<Awaited<ReturnType<typeof getConnector>>>
export type GetConnectorQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetConnector<TData = Awaited<ReturnType<typeof getConnector>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnector>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConnectorQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a connector
 */
export const updateConnector = (
    teamName: string,
    connectorId: string,
    connectorUpdate: ConnectorUpdate,
 ) => {
      
      
      return customFetch<Connector>(
      {url: `/teams/${teamName}/connectors/${connectorId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: connectorUpdate
    },
      );
    }
  


export const getUpdateConnectorMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnector>>, TError,{teamName: string;connectorId: string;data: ConnectorUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateConnector>>, TError,{teamName: string;connectorId: string;data: ConnectorUpdate}, TContext> => {

const mutationKey = ['updateConnector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConnector>>, {teamName: string;connectorId: string;data: ConnectorUpdate}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  updateConnector(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof updateConnector>>>
    export type UpdateConnectorMutationBody = ConnectorUpdate
    export type UpdateConnectorMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateConnector = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnector>>, TError,{teamName: string;connectorId: string;data: ConnectorUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateConnector>>,
        TError,
        {teamName: string;connectorId: string;data: ConnectorUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateConnectorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Revoke authentication for a given connector. Any syncs relying on this connector will stop running until the connector is reauthenticated or sync references are updated.
 */
export const revokeConnector = (
    teamName: string,
    connectorId: string,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate`, method: 'DELETE'
    },
      );
    }
  


export const getRevokeConnectorMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeConnector>>, TError,{teamName: string;connectorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeConnector>>, TError,{teamName: string;connectorId: string}, TContext> => {

const mutationKey = ['revokeConnector'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeConnector>>, {teamName: string;connectorId: string}> = (props) => {
          const {teamName,connectorId} = props ?? {};

          return  revokeConnector(teamName,connectorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof revokeConnector>>>
    
    export type RevokeConnectorMutationError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useRevokeConnector = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeConnector>>, TError,{teamName: string;connectorId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeConnector>>,
        TError,
        {teamName: string;connectorId: string},
        TContext
      > => {

      const mutationOptions = getRevokeConnectorMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get authentication status for the given AWS connector
 */
export const getConnectorAuthStatusAWS = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetConnectorAuthStatusAWS200>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`, method: 'GET', signal
    },
      );
    }
  

export const getGetConnectorAuthStatusAWSQueryKey = (teamName: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/connectors/${connectorId}/authenticate/aws`] as const;
    }

    
export const getGetConnectorAuthStatusAWSQueryOptions = <TData = Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorAuthStatusAWSQueryKey(teamName,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>> = ({ signal }) => getConnectorAuthStatusAWS(teamName,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectorAuthStatusAWSQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>>
export type GetConnectorAuthStatusAWSQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetConnectorAuthStatusAWS<TData = Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectorAuthStatusAWS>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConnectorAuthStatusAWSQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Authenticate or reauthenticate the given AWS connector
 */
export const authenticateConnectorAWS = (
    teamName: string,
    connectorId: string,
    connectorAuthRequestAWS: ConnectorAuthRequestAWS,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ConnectorAuthResponseAWS>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectorAuthRequestAWS, signal
    },
      );
    }
  


export const getAuthenticateConnectorAWSMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestAWS}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestAWS}, TContext> => {

const mutationKey = ['authenticateConnectorAWS'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateConnectorAWS>>, {teamName: string;connectorId: string;data: ConnectorAuthRequestAWS}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  authenticateConnectorAWS(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateConnectorAWSMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateConnectorAWS>>>
    export type AuthenticateConnectorAWSMutationBody = ConnectorAuthRequestAWS
    export type AuthenticateConnectorAWSMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useAuthenticateConnectorAWS = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorAWS>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestAWS}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof authenticateConnectorAWS>>,
        TError,
        {teamName: string;connectorId: string;data: ConnectorAuthRequestAWS},
        TContext
      > => {

      const mutationOptions = getAuthenticateConnectorAWSMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Complete authentication for the given AWS connector
 */
export const authenticateConnectorFinishAWS = (
    teamName: string,
    connectorId: string,
    connectorAuthFinishRequestAWS: ConnectorAuthFinishRequestAWS,
 ) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/aws`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: connectorAuthFinishRequestAWS
    },
      );
    }
  


export const getAuthenticateConnectorFinishAWSMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthFinishRequestAWS}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthFinishRequestAWS}, TContext> => {

const mutationKey = ['authenticateConnectorFinishAWS'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateConnectorFinishAWS>>, {teamName: string;connectorId: string;data: ConnectorAuthFinishRequestAWS}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  authenticateConnectorFinishAWS(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateConnectorFinishAWSMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateConnectorFinishAWS>>>
    export type AuthenticateConnectorFinishAWSMutationBody = ConnectorAuthFinishRequestAWS
    export type AuthenticateConnectorFinishAWSMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useAuthenticateConnectorFinishAWS = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishAWS>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthFinishRequestAWS}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof authenticateConnectorFinishAWS>>,
        TError,
        {teamName: string;connectorId: string;data: ConnectorAuthFinishRequestAWS},
        TContext
      > => {

      const mutationOptions = getAuthenticateConnectorFinishAWSMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get authentication status for the given GCP connector
 */
export const getConnectorAuthStatusGCP = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<GetConnectorAuthStatusGCP200>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`, method: 'GET', signal
    },
      );
    }
  

export const getGetConnectorAuthStatusGCPQueryKey = (teamName: string,
    connectorId: string,) => {
    return [`/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`] as const;
    }

    
export const getGetConnectorAuthStatusGCPQueryOptions = <TData = Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectorAuthStatusGCPQueryKey(teamName,connectorId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>> = ({ signal }) => getConnectorAuthStatusGCP(teamName,connectorId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName && connectorId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConnectorAuthStatusGCPQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>>
export type GetConnectorAuthStatusGCPQueryError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetConnectorAuthStatusGCP<TData = Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>, TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    connectorId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConnectorAuthStatusGCP>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConnectorAuthStatusGCPQueryOptions(teamName,connectorId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Authenticate or reauthenticate the given GCP connector
 */
export const authenticateConnectorGCP = (
    teamName: string,
    connectorId: string,
    connectorAuthRequestGCP: ConnectorAuthRequestGCP,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ConnectorAuthResponseGCP>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectorAuthRequestGCP, signal
    },
      );
    }
  


export const getAuthenticateConnectorGCPMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestGCP}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestGCP}, TContext> => {

const mutationKey = ['authenticateConnectorGCP'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateConnectorGCP>>, {teamName: string;connectorId: string;data: ConnectorAuthRequestGCP}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  authenticateConnectorGCP(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateConnectorGCPMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateConnectorGCP>>>
    export type AuthenticateConnectorGCPMutationBody = ConnectorAuthRequestGCP
    export type AuthenticateConnectorGCPMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useAuthenticateConnectorGCP = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorGCP>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestGCP}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof authenticateConnectorGCP>>,
        TError,
        {teamName: string;connectorId: string;data: ConnectorAuthRequestGCP},
        TContext
      > => {

      const mutationOptions = getAuthenticateConnectorGCPMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Complete authentication for the given GCP connector
 */
export const authenticateConnectorFinishGCP = (
    teamName: string,
    connectorId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/gcp/finish`, method: 'POST', signal
    },
      );
    }
  


export const getAuthenticateConnectorFinishGCPMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext> => {

const mutationKey = ['authenticateConnectorFinishGCP'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateConnectorFinishGCP>>, {teamName: string;connectorId: string}> = (props) => {
          const {teamName,connectorId} = props ?? {};

          return  authenticateConnectorFinishGCP(teamName,connectorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateConnectorFinishGCPMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateConnectorFinishGCP>>>
    
    export type AuthenticateConnectorFinishGCPMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useAuthenticateConnectorFinishGCP = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishGCP>>, TError,{teamName: string;connectorId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof authenticateConnectorFinishGCP>>,
        TError,
        {teamName: string;connectorId: string},
        TContext
      > => {

      const mutationOptions = getAuthenticateConnectorFinishGCPMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Authenticate or reauthenticate the given OAuth connector
 */
export const authenticateConnectorOAuth = (
    teamName: string,
    connectorId: string,
    connectorAuthRequestOAuth: ConnectorAuthRequestOAuth,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ConnectorAuthResponseOAuth>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/oauth`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectorAuthRequestOAuth, signal
    },
      );
    }
  


export const getAuthenticateConnectorOAuthMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestOAuth}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestOAuth}, TContext> => {

const mutationKey = ['authenticateConnectorOAuth'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateConnectorOAuth>>, {teamName: string;connectorId: string;data: ConnectorAuthRequestOAuth}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  authenticateConnectorOAuth(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateConnectorOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateConnectorOAuth>>>
    export type AuthenticateConnectorOAuthMutationBody = ConnectorAuthRequestOAuth
    export type AuthenticateConnectorOAuthMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useAuthenticateConnectorOAuth = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorOAuth>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthRequestOAuth}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof authenticateConnectorOAuth>>,
        TError,
        {teamName: string;connectorId: string;data: ConnectorAuthRequestOAuth},
        TContext
      > => {

      const mutationOptions = getAuthenticateConnectorOAuthMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Complete authentication for the given OAuth connector
 */
export const authenticateConnectorFinishOAuth = (
    teamName: string,
    connectorId: string,
    connectorAuthFinishRequestOAuth: ConnectorAuthFinishRequestOAuth,
 ) => {
      
      
      return customFetch<ConnectorAuthResponseOAuth | void>(
      {url: `/teams/${teamName}/connectors/${connectorId}/authenticate/oauth`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: connectorAuthFinishRequestOAuth
    },
      );
    }
  


export const getAuthenticateConnectorFinishOAuthMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthFinishRequestOAuth}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthFinishRequestOAuth}, TContext> => {

const mutationKey = ['authenticateConnectorFinishOAuth'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateConnectorFinishOAuth>>, {teamName: string;connectorId: string;data: ConnectorAuthFinishRequestOAuth}> = (props) => {
          const {teamName,connectorId,data} = props ?? {};

          return  authenticateConnectorFinishOAuth(teamName,connectorId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthenticateConnectorFinishOAuthMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateConnectorFinishOAuth>>>
    export type AuthenticateConnectorFinishOAuthMutationBody = ConnectorAuthFinishRequestOAuth
    export type AuthenticateConnectorFinishOAuthMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useAuthenticateConnectorFinishOAuth = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateConnectorFinishOAuth>>, TError,{teamName: string;connectorId: string;data: ConnectorAuthFinishRequestOAuth}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof authenticateConnectorFinishOAuth>>,
        TError,
        {teamName: string;connectorId: string;data: ConnectorAuthFinishRequestOAuth},
        TContext
      > => {

      const mutationOptions = getAuthenticateConnectorFinishOAuthMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Activate platform usage by API key
 */
export const activatePlatform = (
    activatePlatformBody: ActivatePlatformBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<ActivatePlatform200 | ActivatePlatform205>(
      {url: `/platform/activate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: activatePlatformBody, signal
    },
      );
    }
  


export const getActivatePlatformMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatform>>, TError,{data: ActivatePlatformBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activatePlatform>>, TError,{data: ActivatePlatformBody}, TContext> => {

const mutationKey = ['activatePlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePlatform>>, {data: ActivatePlatformBody}> = (props) => {
          const {data} = props ?? {};

          return  activatePlatform(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof activatePlatform>>>
    export type ActivatePlatformMutationBody = ActivatePlatformBody
    export type ActivatePlatformMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useActivatePlatform = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatform>>, TError,{data: ActivatePlatformBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof activatePlatform>>,
        TError,
        {data: ActivatePlatformBody},
        TContext
      > => {

      const mutationOptions = getActivatePlatformMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Renew platform activation
 */
export const renewPlatformActivation = (
    renewPlatformActivationBody: RenewPlatformActivationBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<RenewPlatformActivation200 | RenewPlatformActivation205>(
      {url: `/platform/activate/renew`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: renewPlatformActivationBody, signal
    },
      );
    }
  


export const getRenewPlatformActivationMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewPlatformActivation>>, TError,{data: RenewPlatformActivationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof renewPlatformActivation>>, TError,{data: RenewPlatformActivationBody}, TContext> => {

const mutationKey = ['renewPlatformActivation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renewPlatformActivation>>, {data: RenewPlatformActivationBody}> = (props) => {
          const {data} = props ?? {};

          return  renewPlatformActivation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RenewPlatformActivationMutationResult = NonNullable<Awaited<ReturnType<typeof renewPlatformActivation>>>
    export type RenewPlatformActivationMutationBody = RenewPlatformActivationBody
    export type RenewPlatformActivationMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useRenewPlatformActivation = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewPlatformActivation>>, TError,{data: RenewPlatformActivationBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof renewPlatformActivation>>,
        TError,
        {data: RenewPlatformActivationBody},
        TContext
      > => {

      const mutationOptions = getRenewPlatformActivationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Report platform data
 */
export const reportPlatformData = (
    reportPlatformDataBody: ReportPlatformDataBody,
 signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/platform/report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportPlatformDataBody, signal
    },
      );
    }
  


export const getReportPlatformDataMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPlatformData>>, TError,{data: ReportPlatformDataBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reportPlatformData>>, TError,{data: ReportPlatformDataBody}, TContext> => {

const mutationKey = ['reportPlatformData'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportPlatformData>>, {data: ReportPlatformDataBody}> = (props) => {
          const {data} = props ?? {};

          return  reportPlatformData(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReportPlatformDataMutationResult = NonNullable<Awaited<ReturnType<typeof reportPlatformData>>>
    export type ReportPlatformDataMutationBody = ReportPlatformDataBody
    export type ReportPlatformDataMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useReportPlatformData = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPlatformData>>, TError,{data: ReportPlatformDataBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof reportPlatformData>>,
        TError,
        {data: ReportPlatformDataBody},
        TContext
      > => {

      const mutationOptions = getReportPlatformDataMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Get platform feature flags
 */
export const getPlatformFlags = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetch<PlatformFlags>(
      {url: `/platform/flags`, method: 'GET', signal
    },
      );
    }
  

export const getGetPlatformFlagsQueryKey = () => {
    return [`/platform/flags`] as const;
    }

    
export const getGetPlatformFlagsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformFlags>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformFlags>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformFlagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformFlags>>> = ({ signal }) => getPlatformFlags(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformFlags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformFlags>>>
export type GetPlatformFlagsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useGetPlatformFlags<TData = Awaited<ReturnType<typeof getPlatformFlags>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformFlags>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformFlagsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
